var An = Object.defineProperty;
var On = (n, e, t) => e in n ? An(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var m = (n, e, t) => (On(n, typeof e != "symbol" ? e + "" : e, t), t);
import { findChildren as Ke, Node as re, mergeAttributes as ne, InputRule as ot, isTextSelection as Pn, isNodeSelection as Dn, posToDOMRect as Vt, Extension as $, findParentNode as Rn, getMarkRange as yt, combineTransactionSteps as zn, getChangedRanges as Fn, findChildrenInRange as Ln, Mark as Wt, extensions as ue, Editor as Hn } from "@tiptap/core";
import $n from "@tiptap/extension-bold";
import Jn from "@tiptap/extension-code";
import qn from "@tiptap/extension-dropcursor";
import Un from "@tiptap/extension-gapcursor";
import Vn from "@tiptap/extension-hard-break";
import { History as Wn } from "@tiptap/extension-history";
import Kn from "@tiptap/extension-italic";
import Gn from "@tiptap/extension-strike";
import Yn from "@tiptap/extension-text";
import _n from "@tiptap/extension-underline";
import { Link as Kt } from "@tiptap/extension-link";
import { v4 as Xn } from "uuid";
function Gt(n, e, t) {
  for (let r = 0; ; r++) {
    if (r == n.childCount || r == e.childCount)
      return n.childCount == e.childCount ? null : t;
    let o = n.child(r), i = e.child(r);
    if (o == i) {
      t += o.nodeSize;
      continue;
    }
    if (!o.sameMarkup(i))
      return t;
    if (o.isText && o.text != i.text) {
      for (let s = 0; o.text[s] == i.text[s]; s++)
        t++;
      return t;
    }
    if (o.content.size || i.content.size) {
      let s = Gt(o.content, i.content, t + 1);
      if (s != null)
        return s;
    }
    t += o.nodeSize;
  }
}
function Yt(n, e, t, r) {
  for (let o = n.childCount, i = e.childCount; ; ) {
    if (o == 0 || i == 0)
      return o == i ? null : { a: t, b: r };
    let s = n.child(--o), l = e.child(--i), a = s.nodeSize;
    if (s == l) {
      t -= a, r -= a;
      continue;
    }
    if (!s.sameMarkup(l))
      return { a: t, b: r };
    if (s.isText && s.text != l.text) {
      let c = 0, d = Math.min(s.text.length, l.text.length);
      for (; c < d && s.text[s.text.length - c - 1] == l.text[l.text.length - c - 1]; )
        c++, t--, r--;
      return { a: t, b: r };
    }
    if (s.content.size || l.content.size) {
      let c = Yt(s.content, l.content, t - 1, r - 1);
      if (c)
        return c;
    }
    t -= a, r -= a;
  }
}
class g {
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  nodesBetween(e, t, r, o = 0, i) {
    for (let s = 0, l = 0; l < t; s++) {
      let a = this.content[s], c = l + a.nodeSize;
      if (c > e && r(a, o + l, i || null, s) !== !1 && a.content.size) {
        let d = l + 1;
        a.nodesBetween(Math.max(0, e - d), Math.min(a.content.size, t - d), r, o + d);
      }
      l = c;
    }
  }
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  textBetween(e, t, r, o) {
    let i = "", s = !0;
    return this.nodesBetween(e, t, (l, a) => {
      l.isText ? (i += l.text.slice(Math.max(e, a) - a, t - a), s = !r) : l.isLeaf ? (o ? i += typeof o == "function" ? o(l) : o : l.type.spec.leafText && (i += l.type.spec.leafText(l)), s = !r) : !s && l.isBlock && (i += r, s = !0);
    }, 0), i;
  }
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, r = e.firstChild, o = this.content.slice(), i = 0;
    for (t.isText && t.sameMarkup(r) && (o[o.length - 1] = t.withText(t.text + r.text), i = 1); i < e.content.length; i++)
      o.push(e.content[i]);
    return new g(o, this.size + e.size);
  }
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let r = [], o = 0;
    if (t > e)
      for (let i = 0, s = 0; s < t; i++) {
        let l = this.content[i], a = s + l.nodeSize;
        a > e && ((s < e || a > t) && (l.isText ? l = l.cut(Math.max(0, e - s), Math.min(l.text.length, t - s)) : l = l.cut(Math.max(0, e - s - 1), Math.min(l.content.size, t - s - 1))), r.push(l), o += l.nodeSize), s = a;
      }
    return new g(r, o);
  }
  cutByIndex(e, t) {
    return e == t ? g.empty : e == 0 && t == this.content.length ? this : new g(this.content.slice(e, t));
  }
  replaceChild(e, t) {
    let r = this.content[e];
    if (r == t)
      return this;
    let o = this.content.slice(), i = this.size + t.nodeSize - r.nodeSize;
    return o[e] = t, new g(o, i);
  }
  addToStart(e) {
    return new g([e].concat(this.content), this.size + e.nodeSize);
  }
  addToEnd(e) {
    return new g(this.content.concat(e), this.size + e.nodeSize);
  }
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  get childCount() {
    return this.content.length;
  }
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  maybeChild(e) {
    return this.content[e] || null;
  }
  forEach(e) {
    for (let t = 0, r = 0; t < this.content.length; t++) {
      let o = this.content[t];
      e(o, r, t), r += o.nodeSize;
    }
  }
  findDiffStart(e, t = 0) {
    return Gt(this, e, t);
  }
  findDiffEnd(e, t = this.size, r = e.size) {
    return Yt(this, e, t, r);
  }
  findIndex(e, t = -1) {
    if (e == 0)
      return Me(0, e);
    if (e == this.size)
      return Me(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let r = 0, o = 0; ; r++) {
      let i = this.child(r), s = o + i.nodeSize;
      if (s >= e)
        return s == e || t > 0 ? Me(r + 1, s) : Me(r, o);
      o = s;
    }
  }
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  toStringInner() {
    return this.content.join(", ");
  }
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  static fromJSON(e, t) {
    if (!t)
      return g.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new g(t.map(e.nodeFromJSON));
  }
  static fromArray(e) {
    if (!e.length)
      return g.empty;
    let t, r = 0;
    for (let o = 0; o < e.length; o++) {
      let i = e[o];
      r += i.nodeSize, o && i.isText && e[o - 1].sameMarkup(i) ? (t || (t = e.slice(0, o)), t[t.length - 1] = i.withText(t[t.length - 1].text + i.text)) : t && t.push(i);
    }
    return new g(t || e, r);
  }
  static from(e) {
    if (!e)
      return g.empty;
    if (e instanceof g)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new g([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
g.empty = new g([], 0);
const Le = { index: 0, offset: 0 };
function Me(n, e) {
  return Le.index = n, Le.offset = e, Le;
}
function Ge(n, e) {
  if (n === e)
    return !0;
  if (!(n && typeof n == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(n);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (n.length != e.length)
      return !1;
    for (let r = 0; r < n.length; r++)
      if (!Ge(n[r], e[r]))
        return !1;
  } else {
    for (let r in n)
      if (!(r in e) || !Ge(n[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in n))
        return !1;
  }
  return !0;
}
class O {
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  addToSet(e) {
    let t, r = !1;
    for (let o = 0; o < e.length; o++) {
      let i = e[o];
      if (this.eq(i))
        return e;
      if (this.type.excludes(i.type))
        t || (t = e.slice(0, o));
      else {
        if (i.type.excludes(this.type))
          return e;
        !r && i.type.rank > this.type.rank && (t || (t = e.slice(0, o)), t.push(this), r = !0), t && t.push(i);
      }
    }
    return t || (t = e.slice()), r || t.push(this), t;
  }
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  eq(e) {
    return this == e || this.type == e.type && Ge(this.attrs, e.attrs);
  }
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[t.type];
    if (!r)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    return r.create(t.attrs);
  }
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(t[r]))
        return !1;
    return !0;
  }
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return O.none;
    if (e instanceof O)
      return [e];
    let t = e.slice();
    return t.sort((r, o) => r.type.rank - o.type.rank), t;
  }
}
O.none = [];
class jn extends Error {
}
class p {
  constructor(e, t, r) {
    this.content = e, this.openStart = t, this.openEnd = r;
  }
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  insertAt(e, t) {
    let r = Xt(this.content, e + this.openStart, t);
    return r && new p(r, this.openStart, this.openEnd);
  }
  removeBetween(e, t) {
    return new p(_t(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  static fromJSON(e, t) {
    if (!t)
      return p.empty;
    let r = t.openStart || 0, o = t.openEnd || 0;
    if (typeof r != "number" || typeof o != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new p(g.fromJSON(e, t.content), r, o);
  }
  static maxOpen(e, t = !0) {
    let r = 0, o = 0;
    for (let i = e.firstChild; i && !i.isLeaf && (t || !i.type.spec.isolating); i = i.firstChild)
      r++;
    for (let i = e.lastChild; i && !i.isLeaf && (t || !i.type.spec.isolating); i = i.lastChild)
      o++;
    return new p(e, r, o);
  }
}
p.empty = new p(g.empty, 0, 0);
function _t(n, e, t) {
  let { index: r, offset: o } = n.findIndex(e), i = n.maybeChild(r), { index: s, offset: l } = n.findIndex(t);
  if (o == e || i.isText) {
    if (l != t && !n.child(s).isText)
      throw new RangeError("Removing non-flat range");
    return n.cut(0, e).append(n.cut(t));
  }
  if (r != s)
    throw new RangeError("Removing non-flat range");
  return n.replaceChild(r, i.copy(_t(i.content, e - o - 1, t - o - 1)));
}
function Xt(n, e, t, r) {
  let { index: o, offset: i } = n.findIndex(e), s = n.maybeChild(o);
  if (i == e || s.isText)
    return r && !r.canReplace(o, o, t) ? null : n.cut(0, e).append(t).append(n.cut(e));
  let l = Xt(s.content, e - i - 1, t);
  return l && n.replaceChild(o, s.copy(l));
}
class Ne {
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [], t.forEach((r) => {
      r.tag ? this.tags.push(r) : r.style && this.styles.push(r);
    }), this.normalizeLists = !this.tags.some((r) => {
      if (!/^(ul|ol)\b/.test(r.tag) || !r.node)
        return !1;
      let o = e.nodes[r.node];
      return o.contentMatch.matchType(o);
    });
  }
  parse(e, t = {}) {
    let r = new Ct(this, t, !1);
    return r.addAll(e, t.from, t.to), r.finish();
  }
  parseSlice(e, t = {}) {
    let r = new Ct(this, t, !0);
    return r.addAll(e, t.from, t.to), p.maxOpen(r.finish());
  }
  matchTag(e, t, r) {
    for (let o = r ? this.tags.indexOf(r) + 1 : 0; o < this.tags.length; o++) {
      let i = this.tags[o];
      if (er(e, i.tag) && (i.namespace === void 0 || e.namespaceURI == i.namespace) && (!i.context || t.matchesContext(i.context))) {
        if (i.getAttrs) {
          let s = i.getAttrs(e);
          if (s === !1)
            continue;
          i.attrs = s || void 0;
        }
        return i;
      }
    }
  }
  matchStyle(e, t, r, o) {
    for (let i = o ? this.styles.indexOf(o) + 1 : 0; i < this.styles.length; i++) {
      let s = this.styles[i], l = s.style;
      if (!(l.indexOf(e) != 0 || s.context && !r.matchesContext(s.context) || l.length > e.length && (l.charCodeAt(e.length) != 61 || l.slice(e.length + 1) != t))) {
        if (s.getAttrs) {
          let a = s.getAttrs(t);
          if (a === !1)
            continue;
          s.attrs = a || void 0;
        }
        return s;
      }
    }
  }
  static schemaRules(e) {
    let t = [];
    function r(o) {
      let i = o.priority == null ? 50 : o.priority, s = 0;
      for (; s < t.length; s++) {
        let l = t[s];
        if ((l.priority == null ? 50 : l.priority) < i)
          break;
      }
      t.splice(s, 0, o);
    }
    for (let o in e.marks) {
      let i = e.marks[o].spec.parseDOM;
      i && i.forEach((s) => {
        r(s = St(s)), s.mark = o;
      });
    }
    for (let o in e.nodes) {
      let i = e.nodes[o].spec.parseDOM;
      i && i.forEach((s) => {
        r(s = St(s)), s.node = o;
      });
    }
    return t;
  }
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new Ne(e, Ne.schemaRules(e)));
  }
}
const jt = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, Qn = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, Qt = { ol: !0, ul: !0 }, ve = 1, Be = 2, fe = 4;
function bt(n, e, t) {
  return e != null ? (e ? ve : 0) | (e === "full" ? Be : 0) : n && n.whitespace == "pre" ? ve | Be : t & ~fe;
}
class Te {
  constructor(e, t, r, o, i, s, l) {
    this.type = e, this.attrs = t, this.marks = r, this.pendingMarks = o, this.solid = i, this.options = l, this.content = [], this.activeMarks = O.none, this.stashMarks = [], this.match = s || (l & fe ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(g.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let r = this.type.contentMatch, o;
        return (o = r.findWrapping(e.type)) ? (this.match = r, o) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & ve)) {
      let r = this.content[this.content.length - 1], o;
      if (r && r.isText && (o = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let i = r;
        r.text.length == o[0].length ? this.content.pop() : this.content[this.content.length - 1] = i.withText(i.text.slice(0, i.text.length - o[0].length));
      }
    }
    let t = g.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(g.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  popFromStashMark(e) {
    for (let t = this.stashMarks.length - 1; t >= 0; t--)
      if (e.eq(this.stashMarks[t]))
        return this.stashMarks.splice(t, 1)[0];
  }
  applyPending(e) {
    for (let t = 0, r = this.pendingMarks; t < r.length; t++) {
      let o = r[t];
      (this.type ? this.type.allowsMarkType(o.type) : nr(o.type, e)) && !o.isInSet(this.activeMarks) && (this.activeMarks = o.addToSet(this.activeMarks), this.pendingMarks = o.removeFromSet(this.pendingMarks));
    }
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !jt.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class Ct {
  constructor(e, t, r) {
    this.parser = e, this.options = t, this.isOpen = r, this.open = 0;
    let o = t.topNode, i, s = bt(null, t.preserveWhitespace, 0) | (r ? fe : 0);
    o ? i = new Te(o.type, o.attrs, O.none, O.none, !0, t.topMatch || o.type.contentMatch, s) : r ? i = new Te(null, null, O.none, O.none, !0, null, s) : i = new Te(e.schema.topNodeType, null, O.none, O.none, !0, null, s), this.nodes = [i], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  addDOM(e) {
    if (e.nodeType == 3)
      this.addTextNode(e);
    else if (e.nodeType == 1) {
      let t = e.getAttribute("style"), r = t ? this.readStyles(tr(t)) : null, o = this.top;
      if (r != null)
        for (let i = 0; i < r.length; i++)
          this.addPendingMark(r[i]);
      if (this.addElement(e), r != null)
        for (let i = 0; i < r.length; i++)
          this.removePendingMark(r[i], o);
    }
  }
  addTextNode(e) {
    let t = e.nodeValue, r = this.top;
    if (r.options & Be || r.inlineContext(e) || /[^ \t\r\n\u000c]/.test(t)) {
      if (r.options & ve)
        r.options & Be ? t = t.replace(/\r\n?/g, `
`) : t = t.replace(/\r?\n|\r/g, " ");
      else if (t = t.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(t) && this.open == this.nodes.length - 1) {
        let o = r.content[r.content.length - 1], i = e.previousSibling;
        (!o || i && i.nodeName == "BR" || o.isText && /[ \t\r\n\u000c]$/.test(o.text)) && (t = t.slice(1));
      }
      t && this.insertNode(this.parser.schema.text(t)), this.findInText(e);
    } else
      this.findInside(e);
  }
  addElement(e, t) {
    let r = e.nodeName.toLowerCase(), o;
    Qt.hasOwnProperty(r) && this.parser.normalizeLists && Zn(e);
    let i = this.options.ruleFromNode && this.options.ruleFromNode(e) || (o = this.parser.matchTag(e, this, t));
    if (i ? i.ignore : Qn.hasOwnProperty(r))
      this.findInside(e), this.ignoreFallback(e);
    else if (!i || i.skip || i.closeParent) {
      i && i.closeParent ? this.open = Math.max(0, this.open - 1) : i && i.skip.nodeType && (e = i.skip);
      let s, l = this.top, a = this.needsBlock;
      if (jt.hasOwnProperty(r))
        l.content.length && l.content[0].isInline && this.open && (this.open--, l = this.top), s = !0, l.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e);
        return;
      }
      this.addAll(e), s && this.sync(l), this.needsBlock = a;
    } else
      this.addElementByRule(e, i, i.consuming === !1 ? o : void 0);
  }
  leafFallback(e) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`));
  }
  ignoreFallback(e) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"));
  }
  readStyles(e) {
    let t = O.none;
    e:
      for (let r = 0; r < e.length; r += 2)
        for (let o = void 0; ; ) {
          let i = this.parser.matchStyle(e[r], e[r + 1], this, o);
          if (!i)
            continue e;
          if (i.ignore)
            return null;
          if (t = this.parser.schema.marks[i.mark].create(i.attrs).addToSet(t), i.consuming === !1)
            o = i;
          else
            break;
        }
    return t;
  }
  addElementByRule(e, t, r) {
    let o, i, s;
    t.node ? (i = this.parser.schema.nodes[t.node], i.isLeaf ? this.insertNode(i.create(t.attrs)) || this.leafFallback(e) : o = this.enter(i, t.attrs || null, t.preserveWhitespace)) : (s = this.parser.schema.marks[t.mark].create(t.attrs), this.addPendingMark(s));
    let l = this.top;
    if (i && i.isLeaf)
      this.findInside(e);
    else if (r)
      this.addElement(e, r);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((a) => this.insertNode(a));
    else {
      let a = e;
      typeof t.contentElement == "string" ? a = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? a = t.contentElement(e) : t.contentElement && (a = t.contentElement), this.findAround(e, a, !0), this.addAll(a);
    }
    o && this.sync(l) && this.open--, s && this.removePendingMark(s, l);
  }
  addAll(e, t, r) {
    let o = t || 0;
    for (let i = t ? e.childNodes[t] : e.firstChild, s = r == null ? null : e.childNodes[r]; i != s; i = i.nextSibling, ++o)
      this.findAtPoint(e, o), this.addDOM(i);
    this.findAtPoint(e, o);
  }
  findPlace(e) {
    let t, r;
    for (let o = this.open; o >= 0; o--) {
      let i = this.nodes[o], s = i.findWrapping(e);
      if (s && (!t || t.length > s.length) && (t = s, r = i, !s.length) || i.solid)
        break;
    }
    if (!t)
      return !1;
    this.sync(r);
    for (let o = 0; o < t.length; o++)
      this.enterInner(t[o], null, !1);
    return !0;
  }
  insertNode(e) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let t = this.textblockFromContext();
      t && this.enterInner(t);
    }
    if (this.findPlace(e)) {
      this.closeExtra();
      let t = this.top;
      t.applyPending(e.type), t.match && (t.match = t.match.matchType(e.type));
      let r = t.activeMarks;
      for (let o = 0; o < e.marks.length; o++)
        (!t.type || t.type.allowsMarkType(e.marks[o].type)) && (r = e.marks[o].addToSet(r));
      return t.content.push(e.mark(r)), !0;
    }
    return !1;
  }
  enter(e, t, r) {
    let o = this.findPlace(e.create(t));
    return o && this.enterInner(e, t, !0, r), o;
  }
  enterInner(e, t = null, r = !1, o) {
    this.closeExtra();
    let i = this.top;
    i.applyPending(e), i.match = i.match && i.match.matchType(e);
    let s = bt(e, o, i.options);
    i.options & fe && i.content.length == 0 && (s |= fe), this.nodes.push(new Te(e, t, i.activeMarks, i.pendingMarks, r, null, s)), this.open++;
  }
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--)
      if (this.nodes[t] == e)
        return this.open = t, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let r = this.nodes[t].content;
      for (let o = r.length - 1; o >= 0; o--)
        e += r[o].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == t && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, r) {
    if (e != t && this.find)
      for (let o = 0; o < this.find.length; o++)
        this.find[o].pos == null && e.nodeType == 1 && e.contains(this.find[o].node) && t.compareDocumentPosition(this.find[o].node) & (r ? 2 : 4) && (this.find[o].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), r = this.options.context, o = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), i = -(r ? r.depth + 1 : 0) + (o ? 0 : 1), s = (l, a) => {
      for (; l >= 0; l--) {
        let c = t[l];
        if (c == "") {
          if (l == t.length - 1 || l == 0)
            continue;
          for (; a >= i; a--)
            if (s(l - 1, a))
              return !0;
          return !1;
        } else {
          let d = a > 0 || a == 0 && o ? this.nodes[a].type : r && a >= i ? r.node(a - i).type : null;
          if (!d || d.name != c && d.groups.indexOf(c) == -1)
            return !1;
          a--;
        }
      }
      return !0;
    };
    return s(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let r = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let t in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[t];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
  addPendingMark(e) {
    let t = rr(e, this.top.pendingMarks);
    t && this.top.stashMarks.push(t), this.top.pendingMarks = e.addToSet(this.top.pendingMarks);
  }
  removePendingMark(e, t) {
    for (let r = this.open; r >= 0; r--) {
      let o = this.nodes[r];
      if (o.pendingMarks.lastIndexOf(e) > -1)
        o.pendingMarks = e.removeFromSet(o.pendingMarks);
      else {
        o.activeMarks = e.removeFromSet(o.activeMarks);
        let s = o.popFromStashMark(e);
        s && o.type && o.type.allowsMarkType(s.type) && (o.activeMarks = s.addToSet(o.activeMarks));
      }
      if (o == t)
        break;
    }
  }
}
function Zn(n) {
  for (let e = n.firstChild, t = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && Qt.hasOwnProperty(r) && t ? (t.appendChild(e), e = t) : r == "li" ? t = e : r && (t = null);
  }
}
function er(n, e) {
  return (n.matches || n.msMatchesSelector || n.webkitMatchesSelector || n.mozMatchesSelector).call(n, e);
}
function tr(n) {
  let e = /\s*([\w-]+)\s*:\s*([^;]+)/g, t, r = [];
  for (; t = e.exec(n); )
    r.push(t[1], t[2].trim());
  return r;
}
function St(n) {
  let e = {};
  for (let t in n)
    e[t] = n[t];
  return e;
}
function nr(n, e) {
  let t = e.schema.nodes;
  for (let r in t) {
    let o = t[r];
    if (!o.allowsMarkType(n))
      continue;
    let i = [], s = (l) => {
      i.push(l);
      for (let a = 0; a < l.edgeCount; a++) {
        let { type: c, next: d } = l.edge(a);
        if (c == e || i.indexOf(d) < 0 && s(d))
          return !0;
      }
    };
    if (s(o.contentMatch))
      return !0;
  }
}
function rr(n, e) {
  for (let t = 0; t < e.length; t++)
    if (n.eq(e[t]))
      return e[t];
}
class _ {
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  serializeFragment(e, t = {}, r) {
    r || (r = He(t).createDocumentFragment());
    let o = r, i = [];
    return e.forEach((s) => {
      if (i.length || s.marks.length) {
        let l = 0, a = 0;
        for (; l < i.length && a < s.marks.length; ) {
          let c = s.marks[a];
          if (!this.marks[c.type.name]) {
            a++;
            continue;
          }
          if (!c.eq(i[l][0]) || c.type.spec.spanning === !1)
            break;
          l++, a++;
        }
        for (; l < i.length; )
          o = i.pop()[1];
        for (; a < s.marks.length; ) {
          let c = s.marks[a++], d = this.serializeMark(c, s.isInline, t);
          d && (i.push([c, o]), o.appendChild(d.dom), o = d.contentDOM || d.dom);
        }
      }
      o.appendChild(this.serializeNodeInner(s, t));
    }), r;
  }
  serializeNodeInner(e, t) {
    let { dom: r, contentDOM: o } = _.renderSpec(He(t), this.nodes[e.type.name](e));
    if (o) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, o);
    }
    return r;
  }
  serializeNode(e, t = {}) {
    let r = this.serializeNodeInner(e, t);
    for (let o = e.marks.length - 1; o >= 0; o--) {
      let i = this.serializeMark(e.marks[o], e.isInline, t);
      i && ((i.contentDOM || i.dom).appendChild(r), r = i.dom);
    }
    return r;
  }
  serializeMark(e, t, r = {}) {
    let o = this.marks[e.type.name];
    return o && _.renderSpec(He(r), o(e, t));
  }
  static renderSpec(e, t, r = null) {
    if (typeof t == "string")
      return { dom: e.createTextNode(t) };
    if (t.nodeType != null)
      return { dom: t };
    if (t.dom && t.dom.nodeType != null)
      return t;
    let o = t[0], i = o.indexOf(" ");
    i > 0 && (r = o.slice(0, i), o = o.slice(i + 1));
    let s, l = r ? e.createElementNS(r, o) : e.createElement(o), a = t[1], c = 1;
    if (a && typeof a == "object" && a.nodeType == null && !Array.isArray(a)) {
      c = 2;
      for (let d in a)
        if (a[d] != null) {
          let h = d.indexOf(" ");
          h > 0 ? l.setAttributeNS(d.slice(0, h), d.slice(h + 1), a[d]) : l.setAttribute(d, a[d]);
        }
    }
    for (let d = c; d < t.length; d++) {
      let h = t[d];
      if (h === 0) {
        if (d < t.length - 1 || d > c)
          throw new RangeError("Content hole must be the only child of its parent node");
        return { dom: l, contentDOM: l };
      } else {
        let { dom: u, contentDOM: f } = _.renderSpec(e, h, r);
        if (l.appendChild(u), f) {
          if (s)
            throw new RangeError("Multiple content holes");
          s = f;
        }
      }
    }
    return { dom: l, contentDOM: s };
  }
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new _(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  static nodesFromSchema(e) {
    let t = xt(e.nodes);
    return t.text || (t.text = (r) => r.text), t;
  }
  static marksFromSchema(e) {
    return xt(e.marks);
  }
}
function xt(n) {
  let e = {};
  for (let t in n) {
    let r = n[t].spec.toDOM;
    r && (e[t] = r);
  }
  return e;
}
function He(n) {
  return n.document || window.document;
}
const Zt = 65535, en = Math.pow(2, 16);
function or(n, e) {
  return n + e * en;
}
function Mt(n) {
  return n & Zt;
}
function ir(n) {
  return (n - (n & Zt)) / en;
}
const tn = 1, nn = 2, we = 4, rn = 8;
class Tt {
  constructor(e, t, r) {
    this.pos = e, this.delInfo = t, this.recover = r;
  }
  get deleted() {
    return (this.delInfo & rn) > 0;
  }
  get deletedBefore() {
    return (this.delInfo & (tn | we)) > 0;
  }
  get deletedAfter() {
    return (this.delInfo & (nn | we)) > 0;
  }
  get deletedAcross() {
    return (this.delInfo & we) > 0;
  }
}
class D {
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && D.empty)
      return D.empty;
  }
  recover(e) {
    let t = 0, r = Mt(e);
    if (!this.inverted)
      for (let o = 0; o < r; o++)
        t += this.ranges[o * 3 + 2] - this.ranges[o * 3 + 1];
    return this.ranges[r * 3] + t + ir(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  _map(e, t, r) {
    let o = 0, i = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let a = this.ranges[l] - (this.inverted ? o : 0);
      if (a > e)
        break;
      let c = this.ranges[l + i], d = this.ranges[l + s], h = a + c;
      if (e <= h) {
        let u = c ? e == a ? -1 : e == h ? 1 : t : t, f = a + o + (u < 0 ? 0 : d);
        if (r)
          return f;
        let k = e == (t < 0 ? a : h) ? null : or(l / 3, e - a), S = e == a ? nn : e == h ? tn : we;
        return (t < 0 ? e != a : e != h) && (S |= rn), new Tt(f, S, k);
      }
      o += d - c;
    }
    return r ? e + o : new Tt(e + o, 0, null);
  }
  touches(e, t) {
    let r = 0, o = Mt(t), i = this.inverted ? 2 : 1, s = this.inverted ? 1 : 2;
    for (let l = 0; l < this.ranges.length; l += 3) {
      let a = this.ranges[l] - (this.inverted ? r : 0);
      if (a > e)
        break;
      let c = this.ranges[l + i], d = a + c;
      if (e <= d && l == o * 3)
        return !0;
      r += this.ranges[l + s] - c;
    }
    return !1;
  }
  forEach(e) {
    let t = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let o = 0, i = 0; o < this.ranges.length; o += 3) {
      let s = this.ranges[o], l = s - (this.inverted ? i : 0), a = s + (this.inverted ? 0 : i), c = this.ranges[o + t], d = this.ranges[o + r];
      e(l, l + c, a, a + d), i += d - c;
    }
  }
  invert() {
    return new D(this.ranges, !this.inverted);
  }
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  static offset(e) {
    return e == 0 ? D.empty : new D(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
D.empty = new D([]);
const $e = /* @__PURE__ */ Object.create(null);
class v {
  getMap() {
    return D.empty;
  }
  merge(e) {
    return null;
  }
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = $e[t.stepType];
    if (!r)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return r.fromJSON(e, t);
  }
  static jsonID(e, t) {
    if (e in $e)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return $e[e] = t, t.prototype.jsonID = e, t;
  }
}
class E {
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  static ok(e) {
    return new E(e, null);
  }
  static fail(e) {
    return new E(null, e);
  }
  static fromReplace(e, t, r, o) {
    try {
      return E.ok(e.replace(t, r, o));
    } catch (i) {
      if (i instanceof jn)
        return E.fail(i.message);
      throw i;
    }
  }
}
function it(n, e, t) {
  let r = [];
  for (let o = 0; o < n.childCount; o++) {
    let i = n.child(o);
    i.content.size && (i = i.copy(it(i.content, e, i))), i.isInline && (i = e(i, t, o)), r.push(i);
  }
  return g.fromArray(r);
}
class X extends v {
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = e.resolve(this.from), o = r.node(r.sharedDepth(this.to)), i = new p(it(t.content, (s, l) => !s.isAtom || !l.type.allowsMarkType(this.mark.type) ? s : s.mark(this.mark.addToSet(s.marks)), o), t.openStart, t.openEnd);
    return E.fromReplace(e, this.from, this.to, i);
  }
  invert() {
    return new j(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new X(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof X && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new X(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new X(t.from, t.to, e.markFromJSON(t.mark));
  }
}
v.jsonID("addMark", X);
class j extends v {
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = new p(it(t.content, (o) => o.mark(this.mark.removeFromSet(o.marks)), e), t.openStart, t.openEnd);
    return E.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new X(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new j(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof j && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new j(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new j(t.from, t.to, e.markFromJSON(t.mark));
  }
}
v.jsonID("removeMark", j);
class Q extends v {
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return E.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return E.fromReplace(e, this.pos, this.pos + 1, new p(g.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let r = this.mark.addToSet(t.marks);
      if (r.length == t.marks.length) {
        for (let o = 0; o < t.marks.length; o++)
          if (!t.marks[o].isInSet(r))
            return new Q(this.pos, t.marks[o]);
        return new Q(this.pos, this.mark);
      }
    }
    return new ke(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Q(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Q(t.pos, e.markFromJSON(t.mark));
  }
}
v.jsonID("addNodeMark", Q);
class ke extends v {
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return E.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return E.fromReplace(e, this.pos, this.pos + 1, new p(g.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new Q(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new ke(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new ke(t.pos, e.markFromJSON(t.mark));
  }
}
v.jsonID("removeNodeMark", ke);
class H extends v {
  constructor(e, t, r, o = !1) {
    super(), this.from = e, this.to = t, this.slice = r, this.structure = o;
  }
  apply(e) {
    return this.structure && Ye(e, this.from, this.to) ? E.fail("Structure replace would overwrite content") : E.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new D([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new H(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deletedAcross && r.deletedAcross ? null : new H(t.pos, Math.max(t.pos, r.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof H) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? p.empty : new p(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new H(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? p.empty : new p(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new H(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new H(t.from, t.to, p.fromJSON(e, t.slice), !!t.structure);
  }
}
v.jsonID("replace", H);
class ae extends v {
  constructor(e, t, r, o, i, s, l = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = r, this.gapTo = o, this.slice = i, this.insert = s, this.structure = l;
  }
  apply(e) {
    if (this.structure && (Ye(e, this.from, this.gapFrom) || Ye(e, this.gapTo, this.to)))
      return E.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return E.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, t.content);
    return r ? E.fromReplace(e, this.from, this.to, r) : E.fail("Content does not fit in gap");
  }
  getMap() {
    return new D([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new ae(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), o = e.map(this.gapFrom, -1), i = e.map(this.gapTo, 1);
    return t.deletedAcross && r.deletedAcross || o < t.pos || i > r.pos ? null : new ae(t.pos, r.pos, o, i, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new ae(t.from, t.to, t.gapFrom, t.gapTo, p.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
v.jsonID("replaceAround", ae);
function Ye(n, e, t) {
  let r = n.resolve(e), o = t - e, i = r.depth;
  for (; o > 0 && i > 0 && r.indexAfter(i) == r.node(i).childCount; )
    i--, o--;
  if (o > 0) {
    let s = r.node(i).maybeChild(r.indexAfter(i));
    for (; o > 0; ) {
      if (!s || s.isLeaf)
        return !0;
      s = s.firstChild, o--;
    }
  }
  return !1;
}
function sr(n, e, t) {
  let r = n.resolve(e);
  if (!t.content.size)
    return e;
  let o = t.content;
  for (let i = 0; i < t.openStart; i++)
    o = o.firstChild.content;
  for (let i = 1; i <= (t.openStart == 0 && t.size ? 2 : 1); i++)
    for (let s = r.depth; s >= 0; s--) {
      let l = s == r.depth ? 0 : r.pos <= (r.start(s + 1) + r.end(s + 1)) / 2 ? -1 : 1, a = r.index(s) + (l > 0 ? 1 : 0), c = r.node(s), d = !1;
      if (i == 1)
        d = c.canReplace(a, a, o);
      else {
        let h = c.contentMatchAt(a).findWrapping(o.firstChild.type);
        d = h && c.canReplaceWith(a, a, h[0]);
      }
      if (d)
        return l == 0 ? r.pos : l < 0 ? r.before(s + 1) : r.after(s + 1);
    }
  return null;
}
class pe extends v {
  constructor(e, t, r) {
    super(), this.pos = e, this.attr = t, this.value = r;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return E.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in t.attrs)
      r[i] = t.attrs[i];
    r[this.attr] = this.value;
    let o = t.type.create(r, null, t.marks);
    return E.fromReplace(e, this.pos, this.pos + 1, new p(g.from(o), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return D.empty;
  }
  invert(e) {
    return new pe(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new pe(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new pe(t.pos, t.attr, t.value);
  }
}
v.jsonID("attr", pe);
let ye = class extends Error {
};
ye = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
ye.prototype = Object.create(Error.prototype);
ye.prototype.constructor = ye;
ye.prototype.name = "TransformError";
const Je = /* @__PURE__ */ Object.create(null);
class b {
  constructor(e, t, r) {
    this.$anchor = e, this.$head = t, this.ranges = r || [new lr(e.min(t), e.max(t))];
  }
  get anchor() {
    return this.$anchor.pos;
  }
  get head() {
    return this.$head.pos;
  }
  get from() {
    return this.$from.pos;
  }
  get to() {
    return this.$to.pos;
  }
  get $from() {
    return this.ranges[0].$from;
  }
  get $to() {
    return this.ranges[0].$to;
  }
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  replace(e, t = p.empty) {
    let r = t.content.lastChild, o = null;
    for (let l = 0; l < t.openEnd; l++)
      o = r, r = r.lastChild;
    let i = e.steps.length, s = this.ranges;
    for (let l = 0; l < s.length; l++) {
      let { $from: a, $to: c } = s[l], d = e.mapping.slice(i);
      e.replaceRange(d.map(a.pos), d.map(c.pos), l ? p.empty : t), l == 0 && Nt(e, i, (r ? r.isInline : o && o.isTextblock) ? -1 : 1);
    }
  }
  replaceWith(e, t) {
    let r = e.steps.length, o = this.ranges;
    for (let i = 0; i < o.length; i++) {
      let { $from: s, $to: l } = o[i], a = e.mapping.slice(r), c = a.map(s.pos), d = a.map(l.pos);
      i ? e.deleteRange(c, d) : (e.replaceRangeWith(c, d, t), Nt(e, r, t.isInline ? -1 : 1));
    }
  }
  static findFrom(e, t, r = !1) {
    let o = e.parent.inlineContent ? new x(e) : se(e.node(0), e.parent, e.pos, e.index(), t, r);
    if (o)
      return o;
    for (let i = e.depth - 1; i >= 0; i--) {
      let s = t < 0 ? se(e.node(0), e.node(i), e.before(i + 1), e.index(i), t, r) : se(e.node(0), e.node(i), e.after(i + 1), e.index(i) + 1, t, r);
      if (s)
        return s;
    }
    return null;
  }
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new z(e.node(0));
  }
  static atStart(e) {
    return se(e, e, 0, 0, 1) || new z(e);
  }
  static atEnd(e) {
    return se(e, e, e.content.size, e.childCount, -1) || new z(e);
  }
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = Je[t.type];
    if (!r)
      throw new RangeError(`No selection type ${t.type} defined`);
    return r.fromJSON(e, t);
  }
  static jsonID(e, t) {
    if (e in Je)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return Je[e] = t, t.prototype.jsonID = e, t;
  }
  getBookmark() {
    return x.between(this.$anchor, this.$head).getBookmark();
  }
}
b.prototype.visible = !0;
class lr {
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let Et = !1;
function wt(n) {
  !Et && !n.parent.inlineContent && (Et = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + n.parent.type.name + ")"));
}
class x extends b {
  constructor(e, t = e) {
    wt(e), wt(t), super(e, t);
  }
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    if (!r.parent.inlineContent)
      return b.near(r);
    let o = e.resolve(t.map(this.anchor));
    return new x(o.parent.inlineContent ? o : r, r);
  }
  replace(e, t = p.empty) {
    if (super.replace(e, t), t == p.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof x && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new De(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new x(e.resolve(t.anchor), e.resolve(t.head));
  }
  static create(e, t, r = t) {
    let o = e.resolve(t);
    return new this(o, r == t ? o : e.resolve(r));
  }
  static between(e, t, r) {
    let o = e.pos - t.pos;
    if ((!r || o) && (r = o >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let i = b.findFrom(t, r, !0) || b.findFrom(t, -r, !0);
      if (i)
        t = i.$head;
      else
        return b.near(t, r);
    }
    return e.parent.inlineContent || (o == 0 ? e = t : (e = (b.findFrom(e, -r, !0) || b.findFrom(e, r, !0)).$anchor, e.pos < t.pos != o < 0 && (e = t))), new x(e, t);
  }
}
b.jsonID("text", x);
class De {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new De(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return x.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class y extends b {
  constructor(e) {
    let t = e.nodeAfter, r = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, r), this.node = t;
  }
  map(e, t) {
    let { deleted: r, pos: o } = t.mapResult(this.anchor), i = e.resolve(o);
    return r ? b.near(i) : new y(i);
  }
  content() {
    return new p(g.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof y && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new st(this.anchor);
  }
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new y(e.resolve(t.anchor));
  }
  static create(e, t) {
    return new y(e.resolve(t));
  }
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
y.prototype.visible = !1;
b.jsonID("node", y);
class st {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: r } = e.mapResult(this.anchor);
    return t ? new De(r, r) : new st(r);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), r = t.nodeAfter;
    return r && y.isSelectable(r) ? new y(t) : b.near(t);
  }
}
class z extends b {
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = p.empty) {
    if (t == p.empty) {
      e.delete(0, e.doc.content.size);
      let r = b.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  static fromJSON(e) {
    return new z(e);
  }
  map(e) {
    return new z(e);
  }
  eq(e) {
    return e instanceof z;
  }
  getBookmark() {
    return ar;
  }
}
b.jsonID("all", z);
const ar = {
  map() {
    return this;
  },
  resolve(n) {
    return new z(n);
  }
};
function se(n, e, t, r, o, i = !1) {
  if (e.inlineContent)
    return x.create(n, t);
  for (let s = r - (o > 0 ? 0 : 1); o > 0 ? s < e.childCount : s >= 0; s += o) {
    let l = e.child(s);
    if (l.isAtom) {
      if (!i && y.isSelectable(l))
        return y.create(n, t - (o < 0 ? l.nodeSize : 0));
    } else {
      let a = se(n, l, t + o, o < 0 ? l.childCount : 0, o, i);
      if (a)
        return a;
    }
    t += l.nodeSize * o;
  }
  return null;
}
function Nt(n, e, t) {
  let r = n.steps.length - 1;
  if (r < e)
    return;
  let o = n.steps[r];
  if (!(o instanceof H || o instanceof ae))
    return;
  let i = n.mapping.maps[r], s;
  i.forEach((l, a, c, d) => {
    s == null && (s = d);
  }), n.setSelection(b.near(n.doc.resolve(s), t));
}
function vt(n, e) {
  return !e || !n ? n : n.bind(e);
}
class Ee {
  constructor(e, t, r) {
    this.name = e, this.init = vt(t.init, r), this.apply = vt(t.apply, r);
  }
}
new Ee("doc", {
  init(n) {
    return n.doc || n.schema.topNodeType.createAndFill();
  },
  apply(n) {
    return n.doc;
  }
}), new Ee("selection", {
  init(n, e) {
    return n.selection || b.atStart(e.doc);
  },
  apply(n) {
    return n.selection;
  }
}), new Ee("storedMarks", {
  init(n) {
    return n.storedMarks || null;
  },
  apply(n, e, t, r) {
    return r.selection.$cursor ? n.storedMarks : null;
  }
}), new Ee("scrollToSelection", {
  init() {
    return 0;
  },
  apply(n, e) {
    return n.scrolledIntoView ? e + 1 : e;
  }
});
function on(n, e, t) {
  for (let r in n) {
    let o = n[r];
    o instanceof Function ? o = o.bind(e) : r == "handleDOMEvents" && (o = on(o, e, {})), t[r] = o;
  }
  return t;
}
class J {
  constructor(e) {
    this.spec = e, this.props = {}, e.props && on(e.props, this, this.props), this.key = e.key ? e.key.key : sn("plugin");
  }
  getState(e) {
    return e[this.key];
  }
}
const qe = /* @__PURE__ */ Object.create(null);
function sn(n) {
  return n in qe ? n + "$" + ++qe[n] : (qe[n] = 0, n + "$");
}
class L {
  constructor(e = "key") {
    this.key = sn(e);
  }
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  getState(e) {
    return e[this.key];
  }
}
function T(n, e) {
  if (e <= 0 || e > n.nodeSize)
    return;
  const t = n.resolve(e), r = t.depth;
  let o = t.node(r), i = r;
  for (; i >= 0; ) {
    if (i === 0)
      return;
    if (o.type.name === "blockContainer")
      break;
    i -= 1, o = t.node(i);
  }
  const s = o.attrs.id, l = o.firstChild, a = l.type, c = o.childCount === 2 ? o.lastChild.childCount : 0, d = t.start(i), h = t.end(i);
  return {
    id: s,
    node: o,
    contentNode: l,
    contentType: a,
    numChildBlocks: c,
    startPos: d,
    endPos: h,
    depth: i
  };
}
const Ce = function(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}, ln = function(n, e, t, r) {
  return t && (Bt(n, e, t, r, -1) || Bt(n, e, t, r, 1));
}, cr = /^(img|br|input|textarea|hr)$/i;
function Bt(n, e, t, r, o) {
  for (; ; ) {
    if (n == t && e == r)
      return !0;
    if (e == (o < 0 ? 0 : Ie(n))) {
      let i = n.parentNode;
      if (!i || i.nodeType != 1 || hr(n) || cr.test(n.nodeName) || n.contentEditable == "false")
        return !1;
      e = Ce(n) + (o < 0 ? 0 : 1), n = i;
    } else if (n.nodeType == 1) {
      if (n = n.childNodes[e + (o < 0 ? -1 : 0)], n.contentEditable == "false")
        return !1;
      e = o < 0 ? Ie(n) : 0;
    } else
      return !1;
  }
}
function Ie(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function dr(n, e, t) {
  for (let r = e == 0, o = e == Ie(n); r || o; ) {
    if (n == t)
      return !0;
    let i = Ce(n);
    if (n = n.parentNode, !n)
      return !1;
    r = r && i == 0, o = o && i == Ie(n);
  }
}
function hr(n) {
  let e;
  for (let t = n; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == n || e.contentDOM == n);
}
const an = function(n) {
  return n.focusNode && ln(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset);
};
function cn(n, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = n, t.key = t.code = e, t;
}
const V = typeof navigator < "u" ? navigator : null, It = typeof document < "u" ? document : null, W = V && V.userAgent || "", _e = /Edge\/(\d+)/.exec(W), dn = /MSIE \d/.exec(W), Xe = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(W), Se = !!(dn || Xe || _e), hn = dn ? document.documentMode : Xe ? +Xe[1] : _e ? +_e[1] : 0, Re = !Se && /gecko\/(\d+)/i.test(W);
Re && +(/Firefox\/(\d+)/.exec(W) || [0, 0])[1];
const je = !Se && /Chrome\/(\d+)/.exec(W), he = !!je, ur = je ? +je[1] : 0, oe = !Se && !!V && /Apple Computer/.test(V.vendor), lt = oe && (/Mobile\/\w+/.test(W) || !!V && V.maxTouchPoints > 2), P = lt || (V ? /Mac/.test(V.platform) : !1), xe = /Android \d/.test(W), at = !!It && "webkitFontSmoothing" in It.documentElement.style, fr = at ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function pr(n, e = null) {
  let t = n.domSelectionRange(), r = n.state.doc;
  if (!t.focusNode)
    return null;
  let o = n.docView.nearestDesc(t.focusNode), i = o && o.size == 0, s = n.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (s < 0)
    return null;
  let l = r.resolve(s), a, c;
  if (an(t)) {
    for (a = l; o && !o.node; )
      o = o.parent;
    let d = o.node;
    if (o && d.isAtom && y.isSelectable(d) && o.parent && !(d.isInline && dr(t.focusNode, t.focusOffset, o.dom))) {
      let h = o.posBefore;
      c = new y(s == h ? l : r.resolve(h));
    }
  } else {
    let d = n.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (d < 0)
      return null;
    a = r.resolve(d);
  }
  if (!c) {
    let d = e == "pointer" || n.state.selection.head < l.pos && !i ? 1 : -1;
    c = fn(n, a, l, d);
  }
  return c;
}
function un(n) {
  return n.editable ? n.hasFocus() : yr(n) && document.activeElement && document.activeElement.contains(n.dom);
}
function ct(n, e = !1) {
  let t = n.state.selection;
  if (kr(n, t), !!un(n)) {
    if (!e && n.input.mouseDown && n.input.mouseDown.allowDefault && he) {
      let r = n.domSelectionRange(), o = n.domObserver.currentSelection;
      if (r.anchorNode && o.anchorNode && ln(r.anchorNode, r.anchorOffset, o.anchorNode, o.anchorOffset)) {
        n.input.mouseDown.delayedSelectionSync = !0, n.domObserver.setCurSelection();
        return;
      }
    }
    if (n.domObserver.disconnectSelection(), n.cursorWrapper)
      gr(n);
    else {
      let { anchor: r, head: o } = t, i, s;
      At && !(t instanceof x) && (t.$from.parent.inlineContent || (i = Ot(n, t.from)), !t.empty && !t.$from.parent.inlineContent && (s = Ot(n, t.to))), n.docView.setSelection(r, o, n.root, e), At && (i && Pt(i), s && Pt(s)), t.visible ? n.dom.classList.remove("ProseMirror-hideselection") : (n.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && mr(n));
    }
    n.domObserver.setCurSelection(), n.domObserver.connectSelection();
  }
}
const At = oe || he && ur < 63;
function Ot(n, e) {
  let { node: t, offset: r } = n.docView.domFromPos(e, 0), o = r < t.childNodes.length ? t.childNodes[r] : null, i = r ? t.childNodes[r - 1] : null;
  if (oe && o && o.contentEditable == "false")
    return Ue(o);
  if ((!o || o.contentEditable == "false") && (!i || i.contentEditable == "false")) {
    if (o)
      return Ue(o);
    if (i)
      return Ue(i);
  }
}
function Ue(n) {
  return n.contentEditable = "true", oe && n.draggable && (n.draggable = !1, n.wasDraggable = !0), n;
}
function Pt(n) {
  n.contentEditable = "false", n.wasDraggable && (n.draggable = !0, n.wasDraggable = null);
}
function mr(n) {
  let e = n.dom.ownerDocument;
  e.removeEventListener("selectionchange", n.input.hideSelectionGuard);
  let t = n.domSelectionRange(), r = t.anchorNode, o = t.anchorOffset;
  e.addEventListener("selectionchange", n.input.hideSelectionGuard = () => {
    (t.anchorNode != r || t.anchorOffset != o) && (e.removeEventListener("selectionchange", n.input.hideSelectionGuard), setTimeout(() => {
      (!un(n) || n.state.selection.visible) && n.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function gr(n) {
  let e = n.domSelection(), t = document.createRange(), r = n.cursorWrapper.dom, o = r.nodeName == "IMG";
  o ? t.setEnd(r.parentNode, Ce(r) + 1) : t.setEnd(r, 0), t.collapse(!1), e.removeAllRanges(), e.addRange(t), !o && !n.state.selection.visible && Se && hn <= 11 && (r.disabled = !0, r.disabled = !1);
}
function kr(n, e) {
  if (e instanceof y) {
    let t = n.docView.descAt(e.from);
    t != n.lastSelectedViewDesc && (Dt(n), t && t.selectNode(), n.lastSelectedViewDesc = t);
  } else
    Dt(n);
}
function Dt(n) {
  n.lastSelectedViewDesc && (n.lastSelectedViewDesc.parent && n.lastSelectedViewDesc.deselectNode(), n.lastSelectedViewDesc = void 0);
}
function fn(n, e, t, r) {
  return n.someProp("createSelectionBetween", (o) => o(n, e, t)) || x.between(e, t, r);
}
function yr(n) {
  let e = n.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return n.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (n.editable || n.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function Qe(n, e) {
  let { $anchor: t, $head: r } = n.selection, o = e > 0 ? t.max(r) : t.min(r), i = o.parent.inlineContent ? o.depth ? n.doc.resolve(e > 0 ? o.after() : o.before()) : null : o;
  return i && b.findFrom(i, e);
}
function G(n, e) {
  return n.dispatch(n.state.tr.setSelection(e).scrollIntoView()), !0;
}
function Rt(n, e, t) {
  let r = n.state.selection;
  if (r instanceof x) {
    if (!r.empty || t.indexOf("s") > -1)
      return !1;
    if (n.endOfTextblock(e > 0 ? "right" : "left")) {
      let o = Qe(n.state, e);
      return o && o instanceof y ? G(n, o) : !1;
    } else if (!(P && t.indexOf("m") > -1)) {
      let o = r.$head, i = o.textOffset ? null : e < 0 ? o.nodeBefore : o.nodeAfter, s;
      if (!i || i.isText)
        return !1;
      let l = e < 0 ? o.pos - i.nodeSize : o.pos;
      return i.isAtom || (s = n.docView.descAt(l)) && !s.contentDOM ? y.isSelectable(i) ? G(n, new y(e < 0 ? n.state.doc.resolve(o.pos - i.nodeSize) : o)) : at ? G(n, new x(n.state.doc.resolve(e < 0 ? l : l + i.nodeSize))) : !1 : !1;
    }
  } else {
    if (r instanceof y && r.node.isInline)
      return G(n, new x(e > 0 ? r.$to : r.$from));
    {
      let o = Qe(n.state, e);
      return o ? G(n, o) : !1;
    }
  }
}
function Ae(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function me(n) {
  let e = n.pmViewDesc;
  return e && e.size == 0 && (n.nextSibling || n.nodeName != "BR");
}
function Ve(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let o, i, s = !1;
  for (Re && t.nodeType == 1 && r < Ae(t) && me(t.childNodes[r]) && (s = !0); ; )
    if (r > 0) {
      if (t.nodeType != 1)
        break;
      {
        let l = t.childNodes[r - 1];
        if (me(l))
          o = t, i = --r;
        else if (l.nodeType == 3)
          t = l, r = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (pn(t))
        break;
      {
        let l = t.previousSibling;
        for (; l && me(l); )
          o = t.parentNode, i = Ce(l), l = l.previousSibling;
        if (l)
          t = l, r = Ae(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = 0;
        }
      }
    }
  s ? Ze(n, t, r) : o && Ze(n, o, i);
}
function We(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let o = Ae(t), i, s;
  for (; ; )
    if (r < o) {
      if (t.nodeType != 1)
        break;
      let l = t.childNodes[r];
      if (me(l))
        i = t, s = ++r;
      else
        break;
    } else {
      if (pn(t))
        break;
      {
        let l = t.nextSibling;
        for (; l && me(l); )
          i = l.parentNode, s = Ce(l) + 1, l = l.nextSibling;
        if (l)
          t = l, r = 0, o = Ae(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = o = 0;
        }
      }
    }
  i && Ze(n, i, s);
}
function pn(n) {
  let e = n.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function Ze(n, e, t) {
  let r = n.domSelection();
  if (an(r)) {
    let i = document.createRange();
    i.setEnd(e, t), i.setStart(e, t), r.removeAllRanges(), r.addRange(i);
  } else
    r.extend && r.extend(e, t);
  n.domObserver.setCurSelection();
  let { state: o } = n;
  setTimeout(() => {
    n.state == o && ct(n);
  }, 50);
}
function zt(n, e, t) {
  let r = n.state.selection;
  if (r instanceof x && !r.empty || t.indexOf("s") > -1 || P && t.indexOf("m") > -1)
    return !1;
  let { $from: o, $to: i } = r;
  if (!o.parent.inlineContent || n.endOfTextblock(e < 0 ? "up" : "down")) {
    let s = Qe(n.state, e);
    if (s && s instanceof y)
      return G(n, s);
  }
  if (!o.parent.inlineContent) {
    let s = e < 0 ? o : i, l = r instanceof z ? b.near(s, e) : b.findFrom(s, e);
    return l ? G(n, l) : !1;
  }
  return !1;
}
function Ft(n, e) {
  if (!(n.state.selection instanceof x))
    return !0;
  let { $head: t, $anchor: r, empty: o } = n.state.selection;
  if (!t.sameParent(r))
    return !0;
  if (!o)
    return !1;
  if (n.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let i = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (i && !i.isText) {
    let s = n.state.tr;
    return e < 0 ? s.delete(t.pos - i.nodeSize, t.pos) : s.delete(t.pos, t.pos + i.nodeSize), n.dispatch(s), !0;
  }
  return !1;
}
function Lt(n, e, t) {
  n.domObserver.stop(), e.contentEditable = t, n.domObserver.start();
}
function br(n) {
  if (!oe || n.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    Lt(n, r, "true"), setTimeout(() => Lt(n, r, "false"), 20);
  }
  return !1;
}
function Cr(n) {
  let e = "";
  return n.ctrlKey && (e += "c"), n.metaKey && (e += "m"), n.altKey && (e += "a"), n.shiftKey && (e += "s"), e;
}
function Sr(n, e) {
  let t = e.keyCode, r = Cr(e);
  return t == 8 || P && t == 72 && r == "c" ? Ft(n, -1) || Ve(n) : t == 46 || P && t == 68 && r == "c" ? Ft(n, 1) || We(n) : t == 13 || t == 27 ? !0 : t == 37 || P && t == 66 && r == "c" ? Rt(n, -1, r) || Ve(n) : t == 39 || P && t == 70 && r == "c" ? Rt(n, 1, r) || We(n) : t == 38 || P && t == 80 && r == "c" ? zt(n, -1, r) || Ve(n) : t == 40 || P && t == 78 && r == "c" ? br(n) || zt(n, 1, r) || We(n) : r == (P ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90);
}
function dt(n, e) {
  n.someProp("transformCopied", (f) => {
    e = f(e, n);
  });
  let t = [], { content: r, openStart: o, openEnd: i } = e;
  for (; o > 1 && i > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    o--, i--;
    let f = r.firstChild;
    t.push(f.type.name, f.attrs != f.type.defaultAttrs ? f.attrs : null), r = f.content;
  }
  let s = n.someProp("clipboardSerializer") || _.fromSchema(n.state.schema), l = Cn(), a = l.createElement("div");
  a.appendChild(s.serializeFragment(r, { document: l }));
  let c = a.firstChild, d, h = 0;
  for (; c && c.nodeType == 1 && (d = bn[c.nodeName.toLowerCase()]); ) {
    for (let f = d.length - 1; f >= 0; f--) {
      let k = l.createElement(d[f]);
      for (; a.firstChild; )
        k.appendChild(a.firstChild);
      a.appendChild(k), h++;
    }
    c = a.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${o} ${i}${h ? ` -${h}` : ""} ${JSON.stringify(t)}`);
  let u = n.someProp("clipboardTextSerializer", (f) => f(e, n)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: a, text: u };
}
function mn(n, e, t, r, o) {
  let i = o.parent.type.spec.code, s, l;
  if (!t && !e)
    return null;
  let a = e && (r || i || !t);
  if (a) {
    if (n.someProp("transformPastedText", (u) => {
      e = u(e, i || r, n);
    }), i)
      return e ? new p(g.from(n.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : p.empty;
    let h = n.someProp("clipboardTextParser", (u) => u(e, o, r, n));
    if (h)
      l = h;
    else {
      let u = o.marks(), { schema: f } = n.state, k = _.fromSchema(f);
      s = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((S) => {
        let C = s.appendChild(document.createElement("p"));
        S && C.appendChild(k.serializeNode(f.text(S, u)));
      });
    }
  } else
    n.someProp("transformPastedHTML", (h) => {
      t = h(t, n);
    }), s = Tr(t), at && Er(s);
  let c = s && s.querySelector("[data-pm-slice]"), d = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (d && d[3])
    for (let h = +d[3]; h > 0; h--) {
      let u = s.firstChild;
      for (; u && u.nodeType != 1; )
        u = u.nextSibling;
      if (!u)
        break;
      s = u;
    }
  if (l || (l = (n.someProp("clipboardParser") || n.someProp("domParser") || Ne.fromSchema(n.state.schema)).parseSlice(s, {
    preserveWhitespace: !!(a || d),
    context: o,
    ruleFromNode(u) {
      return u.nodeName == "BR" && !u.nextSibling && u.parentNode && !xr.test(u.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), d)
    l = wr(Ht(l, +d[1], +d[2]), d[4]);
  else if (l = p.maxOpen(Mr(l.content, o), !0), l.openStart || l.openEnd) {
    let h = 0, u = 0;
    for (let f = l.content.firstChild; h < l.openStart && !f.type.spec.isolating; h++, f = f.firstChild)
      ;
    for (let f = l.content.lastChild; u < l.openEnd && !f.type.spec.isolating; u++, f = f.lastChild)
      ;
    l = Ht(l, h, u);
  }
  return n.someProp("transformPasted", (h) => {
    l = h(l, n);
  }), l;
}
const xr = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function Mr(n, e) {
  if (n.childCount < 2)
    return n;
  for (let t = e.depth; t >= 0; t--) {
    let o = e.node(t).contentMatchAt(e.index(t)), i, s = [];
    if (n.forEach((l) => {
      if (!s)
        return;
      let a = o.findWrapping(l.type), c;
      if (!a)
        return s = null;
      if (c = s.length && i.length && kn(a, i, l, s[s.length - 1], 0))
        s[s.length - 1] = c;
      else {
        s.length && (s[s.length - 1] = yn(s[s.length - 1], i.length));
        let d = gn(l, a);
        s.push(d), o = o.matchType(d.type), i = a;
      }
    }), s)
      return g.from(s);
  }
  return n;
}
function gn(n, e, t = 0) {
  for (let r = e.length - 1; r >= t; r--)
    n = e[r].create(null, g.from(n));
  return n;
}
function kn(n, e, t, r, o) {
  if (o < n.length && o < e.length && n[o] == e[o]) {
    let i = kn(n, e, t, r.lastChild, o + 1);
    if (i)
      return r.copy(r.content.replaceChild(r.childCount - 1, i));
    if (r.contentMatchAt(r.childCount).matchType(o == n.length - 1 ? t.type : n[o + 1]))
      return r.copy(r.content.append(g.from(gn(t, n, o + 1))));
  }
}
function yn(n, e) {
  if (e == 0)
    return n;
  let t = n.content.replaceChild(n.childCount - 1, yn(n.lastChild, e - 1)), r = n.contentMatchAt(n.childCount).fillBefore(g.empty, !0);
  return n.copy(t.append(r));
}
function et(n, e, t, r, o, i) {
  let s = e < 0 ? n.firstChild : n.lastChild, l = s.content;
  return o < r - 1 && (l = et(l, e, t, r, o + 1, i)), o >= t && (l = e < 0 ? s.contentMatchAt(0).fillBefore(l, n.childCount > 1 || i <= o).append(l) : l.append(s.contentMatchAt(s.childCount).fillBefore(g.empty, !0))), n.replaceChild(e < 0 ? 0 : n.childCount - 1, s.copy(l));
}
function Ht(n, e, t) {
  return e < n.openStart && (n = new p(et(n.content, -1, e, n.openStart, 0, n.openEnd), e, n.openEnd)), t < n.openEnd && (n = new p(et(n.content, 1, t, n.openEnd, 0, 0), n.openStart, t)), n;
}
const bn = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let $t = null;
function Cn() {
  return $t || ($t = document.implementation.createHTMLDocument("title"));
}
function Tr(n) {
  let e = /^(\s*<meta [^>]*>)*/.exec(n);
  e && (n = n.slice(e[0].length));
  let t = Cn().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(n), o;
  if ((o = r && bn[r[1].toLowerCase()]) && (n = o.map((i) => "<" + i + ">").join("") + n + o.map((i) => "</" + i + ">").reverse().join("")), t.innerHTML = n, o)
    for (let i = 0; i < o.length; i++)
      t = t.querySelector(o[i]) || t;
  return t;
}
function Er(n) {
  let e = n.querySelectorAll(he ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    r.childNodes.length == 1 && r.textContent == "\xA0" && r.parentNode && r.parentNode.replaceChild(n.ownerDocument.createTextNode(" "), r);
  }
}
function wr(n, e) {
  if (!n.size)
    return n;
  let t = n.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return n;
  }
  let { content: o, openStart: i, openEnd: s } = n;
  for (let l = r.length - 2; l >= 0; l -= 2) {
    let a = t.nodes[r[l]];
    if (!a || a.hasRequiredAttrs())
      break;
    o = g.from(a.create(r[l + 1], o)), i++, s++;
  }
  return new p(o, i, s);
}
const R = {}, A = {};
function q(n, e) {
  n.input.lastSelectionOrigin = e, n.input.lastSelectionTime = Date.now();
}
A.keydown = (n, e) => {
  let t = e;
  if (n.input.shiftKey = t.keyCode == 16 || t.shiftKey, !xn(n, t) && (n.input.lastKeyCode = t.keyCode, n.input.lastKeyCodeTime = Date.now(), !(xe && he && t.keyCode == 13)))
    if (t.keyCode != 229 && n.domObserver.forceFlush(), lt && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let r = Date.now();
      n.input.lastIOSEnter = r, n.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        n.input.lastIOSEnter == r && (n.someProp("handleKeyDown", (o) => o(n, cn(13, "Enter"))), n.input.lastIOSEnter = 0);
      }, 200);
    } else
      n.someProp("handleKeyDown", (r) => r(n, t)) || Sr(n, t) ? t.preventDefault() : q(n, "key");
};
A.keyup = (n, e) => {
  e.keyCode == 16 && (n.input.shiftKey = !1);
};
A.keypress = (n, e) => {
  let t = e;
  if (xn(n, t) || !t.charCode || t.ctrlKey && !t.altKey || P && t.metaKey)
    return;
  if (n.someProp("handleKeyPress", (o) => o(n, t))) {
    t.preventDefault();
    return;
  }
  let r = n.state.selection;
  if (!(r instanceof x) || !r.$from.sameParent(r.$to)) {
    let o = String.fromCharCode(t.charCode);
    !/[\r\n]/.test(o) && !n.someProp("handleTextInput", (i) => i(n, r.$from.pos, r.$to.pos, o)) && n.dispatch(n.state.tr.insertText(o).scrollIntoView()), t.preventDefault();
  }
};
function ze(n) {
  return { left: n.clientX, top: n.clientY };
}
function Nr(n, e) {
  let t = e.x - n.clientX, r = e.y - n.clientY;
  return t * t + r * r < 100;
}
function ht(n, e, t, r, o) {
  if (r == -1)
    return !1;
  let i = n.state.doc.resolve(r);
  for (let s = i.depth + 1; s > 0; s--)
    if (n.someProp(e, (l) => s > i.depth ? l(n, t, i.nodeAfter, i.before(s), o, !0) : l(n, t, i.node(s), i.before(s), o, !1)))
      return !0;
  return !1;
}
function ce(n, e, t) {
  n.focused || n.focus();
  let r = n.state.tr.setSelection(e);
  t == "pointer" && r.setMeta("pointer", !0), n.dispatch(r);
}
function vr(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.doc.resolve(e), r = t.nodeAfter;
  return r && r.isAtom && y.isSelectable(r) ? (ce(n, new y(t), "pointer"), !0) : !1;
}
function Br(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.selection, r, o;
  t instanceof y && (r = t.node);
  let i = n.state.doc.resolve(e);
  for (let s = i.depth + 1; s > 0; s--) {
    let l = s > i.depth ? i.nodeAfter : i.node(s);
    if (y.isSelectable(l)) {
      r && t.$from.depth > 0 && s >= t.$from.depth && i.before(t.$from.depth + 1) == t.$from.pos ? o = i.before(t.$from.depth) : o = i.before(s);
      break;
    }
  }
  return o != null ? (ce(n, y.create(n.state.doc, o), "pointer"), !0) : !1;
}
function Ir(n, e, t, r, o) {
  return ht(n, "handleClickOn", e, t, r) || n.someProp("handleClick", (i) => i(n, e, r)) || (o ? Br(n, t) : vr(n, t));
}
function Ar(n, e, t, r) {
  return ht(n, "handleDoubleClickOn", e, t, r) || n.someProp("handleDoubleClick", (o) => o(n, e, r));
}
function Or(n, e, t, r) {
  return ht(n, "handleTripleClickOn", e, t, r) || n.someProp("handleTripleClick", (o) => o(n, e, r)) || Pr(n, t, r);
}
function Pr(n, e, t) {
  if (t.button != 0)
    return !1;
  let r = n.state.doc;
  if (e == -1)
    return r.inlineContent ? (ce(n, x.create(r, 0, r.content.size), "pointer"), !0) : !1;
  let o = r.resolve(e);
  for (let i = o.depth + 1; i > 0; i--) {
    let s = i > o.depth ? o.nodeAfter : o.node(i), l = o.before(i);
    if (s.inlineContent)
      ce(n, x.create(r, l + 1, l + 1 + s.content.size), "pointer");
    else if (y.isSelectable(s))
      ce(n, y.create(r, l), "pointer");
    else
      continue;
    return !0;
  }
}
function ut(n) {
  return Oe(n);
}
const Sn = P ? "metaKey" : "ctrlKey";
R.mousedown = (n, e) => {
  let t = e;
  n.input.shiftKey = t.shiftKey;
  let r = ut(n), o = Date.now(), i = "singleClick";
  o - n.input.lastClick.time < 500 && Nr(t, n.input.lastClick) && !t[Sn] && (n.input.lastClick.type == "singleClick" ? i = "doubleClick" : n.input.lastClick.type == "doubleClick" && (i = "tripleClick")), n.input.lastClick = { time: o, x: t.clientX, y: t.clientY, type: i };
  let s = n.posAtCoords(ze(t));
  !s || (i == "singleClick" ? (n.input.mouseDown && n.input.mouseDown.done(), n.input.mouseDown = new Dr(n, s, t, !!r)) : (i == "doubleClick" ? Ar : Or)(n, s.pos, s.inside, t) ? t.preventDefault() : q(n, "pointer"));
};
class Dr {
  constructor(e, t, r, o) {
    this.view = e, this.pos = t, this.event = r, this.flushed = o, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[Sn], this.allowDefault = r.shiftKey;
    let i, s;
    if (t.inside > -1)
      i = e.state.doc.nodeAt(t.inside), s = t.inside;
    else {
      let d = e.state.doc.resolve(t.pos);
      i = d.parent, s = d.depth ? d.before() : 0;
    }
    const l = o ? null : r.target, a = l ? e.docView.nearestDesc(l, !0) : null;
    this.target = a ? a.dom : null;
    let { selection: c } = e.state;
    (r.button == 0 && i.type.spec.draggable && i.type.spec.selectable !== !1 || c instanceof y && c.from <= s && c.to > s) && (this.mightDrag = {
      node: i,
      pos: s,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Re && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), q(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => ct(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(ze(e))), this.updateAllowDefault(e), this.allowDefault || !t ? q(this.view, "pointer") : Ir(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || oe && this.mightDrag && !this.mightDrag.node.isAtom || he && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (ce(this.view, b.near(this.view.state.doc.resolve(t.pos)), "pointer"), e.preventDefault()) : q(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), q(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
R.touchstart = (n) => {
  n.input.lastTouch = Date.now(), ut(n), q(n, "pointer");
};
R.touchmove = (n) => {
  n.input.lastTouch = Date.now(), q(n, "pointer");
};
R.contextmenu = (n) => ut(n);
function xn(n, e) {
  return n.composing ? !0 : oe && Math.abs(e.timeStamp - n.input.compositionEndedAt) < 500 ? (n.input.compositionEndedAt = -2e8, !0) : !1;
}
const Rr = xe ? 5e3 : -1;
A.compositionstart = A.compositionupdate = (n) => {
  if (!n.composing) {
    n.domObserver.flush();
    let { state: e } = n, t = e.selection.$from;
    if (e.selection.empty && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      n.markCursor = n.state.storedMarks || t.marks(), Oe(n, !0), n.markCursor = null;
    else if (Oe(n), Re && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let r = n.domSelectionRange();
      for (let o = r.focusNode, i = r.focusOffset; o && o.nodeType == 1 && i != 0; ) {
        let s = i < 0 ? o.lastChild : o.childNodes[i - 1];
        if (!s)
          break;
        if (s.nodeType == 3) {
          n.domSelection().collapse(s, s.nodeValue.length);
          break;
        } else
          o = s, i = -1;
      }
    }
    n.input.composing = !0;
  }
  Mn(n, Rr);
};
A.compositionend = (n, e) => {
  n.composing && (n.input.composing = !1, n.input.compositionEndedAt = e.timeStamp, Mn(n, 20));
};
function Mn(n, e) {
  clearTimeout(n.input.composingTimeout), e > -1 && (n.input.composingTimeout = setTimeout(() => Oe(n), e));
}
function zr(n) {
  for (n.composing && (n.input.composing = !1, n.input.compositionEndedAt = Fr()); n.input.compositionNodes.length > 0; )
    n.input.compositionNodes.pop().markParentsDirty();
}
function Fr() {
  let n = document.createEvent("Event");
  return n.initEvent("event", !0, !0), n.timeStamp;
}
function Oe(n, e = !1) {
  if (!(xe && n.domObserver.flushingSoon >= 0)) {
    if (n.domObserver.forceFlush(), zr(n), e || n.docView && n.docView.dirty) {
      let t = pr(n);
      return t && !t.eq(n.state.selection) ? n.dispatch(n.state.tr.setSelection(t)) : n.updateState(n.state), !0;
    }
    return !1;
  }
}
function Lr(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), o = document.createRange();
  o.selectNodeContents(e), n.dom.blur(), r.removeAllRanges(), r.addRange(o), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), n.focus();
  }, 50);
}
const de = Se && hn < 15 || lt && fr < 604;
R.copy = A.cut = (n, e) => {
  let t = e, r = n.state.selection, o = t.type == "cut";
  if (r.empty)
    return;
  let i = de ? null : t.clipboardData, s = r.content(), { dom: l, text: a } = dt(n, s);
  i ? (t.preventDefault(), i.clearData(), i.setData("text/html", l.innerHTML), i.setData("text/plain", a)) : Lr(n, l), o && n.dispatch(n.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function Hr(n) {
  return n.openStart == 0 && n.openEnd == 0 && n.content.childCount == 1 ? n.content.firstChild : null;
}
function $r(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.input.shiftKey || n.state.selection.$from.parent.type.spec.code, r = n.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus(), setTimeout(() => {
    n.focus(), r.parentNode && r.parentNode.removeChild(r), t ? tt(n, r.value, null, n.input.shiftKey, e) : tt(n, r.textContent, r.innerHTML, n.input.shiftKey, e);
  }, 50);
}
function tt(n, e, t, r, o) {
  let i = mn(n, e, t, r, n.state.selection.$from);
  if (n.someProp("handlePaste", (a) => a(n, o, i || p.empty)))
    return !0;
  if (!i)
    return !1;
  let s = Hr(i), l = s ? n.state.tr.replaceSelectionWith(s, n.input.shiftKey) : n.state.tr.replaceSelection(i);
  return n.dispatch(l.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
A.paste = (n, e) => {
  let t = e;
  if (n.composing && !xe)
    return;
  let r = de ? null : t.clipboardData;
  r && tt(n, r.getData("text/plain"), r.getData("text/html"), n.input.shiftKey, t) ? t.preventDefault() : $r(n, t);
};
class Jr {
  constructor(e, t) {
    this.slice = e, this.move = t;
  }
}
const Tn = P ? "altKey" : "ctrlKey";
R.dragstart = (n, e) => {
  let t = e, r = n.input.mouseDown;
  if (r && r.done(), !t.dataTransfer)
    return;
  let o = n.state.selection, i = o.empty ? null : n.posAtCoords(ze(t));
  if (!(i && i.pos >= o.from && i.pos <= (o instanceof y ? o.to - 1 : o.to))) {
    if (r && r.mightDrag)
      n.dispatch(n.state.tr.setSelection(y.create(n.state.doc, r.mightDrag.pos)));
    else if (t.target && t.target.nodeType == 1) {
      let c = n.docView.nearestDesc(t.target, !0);
      c && c.node.type.spec.draggable && c != n.docView && n.dispatch(n.state.tr.setSelection(y.create(n.state.doc, c.posBefore)));
    }
  }
  let s = n.state.selection.content(), { dom: l, text: a } = dt(n, s);
  t.dataTransfer.clearData(), t.dataTransfer.setData(de ? "Text" : "text/html", l.innerHTML), t.dataTransfer.effectAllowed = "copyMove", de || t.dataTransfer.setData("text/plain", a), n.dragging = new Jr(s, !t[Tn]);
};
R.dragend = (n) => {
  let e = n.dragging;
  window.setTimeout(() => {
    n.dragging == e && (n.dragging = null);
  }, 50);
};
A.dragover = A.dragenter = (n, e) => e.preventDefault();
A.drop = (n, e) => {
  let t = e, r = n.dragging;
  if (n.dragging = null, !t.dataTransfer)
    return;
  let o = n.posAtCoords(ze(t));
  if (!o)
    return;
  let i = n.state.doc.resolve(o.pos), s = r && r.slice;
  s ? n.someProp("transformPasted", (k) => {
    s = k(s, n);
  }) : s = mn(n, t.dataTransfer.getData(de ? "Text" : "text/plain"), de ? null : t.dataTransfer.getData("text/html"), !1, i);
  let l = !!(r && !t[Tn]);
  if (n.someProp("handleDrop", (k) => k(n, t, s || p.empty, l))) {
    t.preventDefault();
    return;
  }
  if (!s)
    return;
  t.preventDefault();
  let a = s ? sr(n.state.doc, i.pos, s) : i.pos;
  a == null && (a = i.pos);
  let c = n.state.tr;
  l && c.deleteSelection();
  let d = c.mapping.map(a), h = s.openStart == 0 && s.openEnd == 0 && s.content.childCount == 1, u = c.doc;
  if (h ? c.replaceRangeWith(d, d, s.content.firstChild) : c.replaceRange(d, d, s), c.doc.eq(u))
    return;
  let f = c.doc.resolve(d);
  if (h && y.isSelectable(s.content.firstChild) && f.nodeAfter && f.nodeAfter.sameMarkup(s.content.firstChild))
    c.setSelection(new y(f));
  else {
    let k = c.mapping.map(a);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((S, C, w, B) => k = B), c.setSelection(fn(n, f, c.doc.resolve(k)));
  }
  n.focus(), n.dispatch(c.setMeta("uiEvent", "drop"));
};
R.focus = (n) => {
  n.input.lastFocus = Date.now(), n.focused || (n.domObserver.stop(), n.dom.classList.add("ProseMirror-focused"), n.domObserver.start(), n.focused = !0, setTimeout(() => {
    n.docView && n.hasFocus() && !n.domObserver.currentSelection.eq(n.domSelectionRange()) && ct(n);
  }, 20));
};
R.blur = (n, e) => {
  let t = e;
  n.focused && (n.domObserver.stop(), n.dom.classList.remove("ProseMirror-focused"), n.domObserver.start(), t.relatedTarget && n.dom.contains(t.relatedTarget) && n.domObserver.currentSelection.clear(), n.focused = !1);
};
R.beforeinput = (n, e) => {
  if (he && xe && e.inputType == "deleteContentBackward") {
    n.domObserver.flushSoon();
    let { domChangeCount: r } = n.input;
    setTimeout(() => {
      if (n.input.domChangeCount != r || (n.dom.blur(), n.focus(), n.someProp("handleKeyDown", (i) => i(n, cn(8, "Backspace")))))
        return;
      let { $cursor: o } = n.state.selection;
      o && o.pos > 0 && n.dispatch(n.state.tr.delete(o.pos - 1, o.pos).scrollIntoView());
    }, 50);
  }
};
for (let n in A)
  R[n] = A[n];
function be(n, e) {
  if (n == e)
    return !0;
  for (let t in n)
    if (n[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in n))
      return !1;
  return !0;
}
class ft {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || Z, this.side = this.spec.side || 0;
  }
  map(e, t, r, o) {
    let { pos: i, deleted: s } = e.mapResult(t.from + o, this.side < 0 ? -1 : 1);
    return s ? null : new I(i - r, i - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof ft && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && be(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class U {
  constructor(e, t) {
    this.attrs = e, this.spec = t || Z;
  }
  map(e, t, r, o) {
    let i = e.map(t.from + o, this.spec.inclusiveStart ? -1 : 1) - r, s = e.map(t.to + o, this.spec.inclusiveEnd ? 1 : -1) - r;
    return i >= s ? null : new I(i, s, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof U && be(this.attrs, e.attrs) && be(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof U;
  }
  destroy() {
  }
}
class pt {
  constructor(e, t) {
    this.attrs = e, this.spec = t || Z;
  }
  map(e, t, r, o) {
    let i = e.mapResult(t.from + o, 1);
    if (i.deleted)
      return null;
    let s = e.mapResult(t.to + o, -1);
    return s.deleted || s.pos <= i.pos ? null : new I(i.pos - r, s.pos - r, this);
  }
  valid(e, t) {
    let { index: r, offset: o } = e.content.findIndex(t.from), i;
    return o == t.from && !(i = e.child(r)).isText && o + i.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof pt && be(this.attrs, e.attrs) && be(this.spec, e.spec);
  }
  destroy() {
  }
}
class I {
  constructor(e, t, r) {
    this.from = e, this.to = t, this.type = r;
  }
  copy(e, t) {
    return new I(e, t, this.type);
  }
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  map(e, t, r) {
    return this.type.map(e, this, t, r);
  }
  static widget(e, t, r) {
    return new I(e, e, new ft(t, r));
  }
  static inline(e, t, r, o) {
    return new I(e, t, new U(r, o));
  }
  static node(e, t, r, o) {
    return new I(e, t, new pt(r, o));
  }
  get spec() {
    return this.type.spec;
  }
  get inline() {
    return this.type instanceof U;
  }
}
const le = [], Z = {};
class M {
  constructor(e, t) {
    this.local = e.length ? e : le, this.children = t.length ? t : le;
  }
  static create(e, t) {
    return t.length ? Pe(t, e, 0, Z) : N;
  }
  find(e, t, r) {
    let o = [];
    return this.findInner(e == null ? 0 : e, t == null ? 1e9 : t, o, 0, r), o;
  }
  findInner(e, t, r, o, i) {
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s];
      l.from <= t && l.to >= e && (!i || i(l.spec)) && r.push(l.copy(l.from + o, l.to + o));
    }
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] < t && this.children[s + 1] > e) {
        let l = this.children[s] + 1;
        this.children[s + 2].findInner(e - l, t - l, r, o + l, i);
      }
  }
  map(e, t, r) {
    return this == N || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, r || Z);
  }
  mapInner(e, t, r, o, i) {
    let s;
    for (let l = 0; l < this.local.length; l++) {
      let a = this.local[l].map(e, r, o);
      a && a.type.valid(t, a) ? (s || (s = [])).push(a) : i.onRemove && i.onRemove(this.local[l].spec);
    }
    return this.children.length ? qr(this.children, s || [], e, t, r, o, i) : s ? new M(s.sort(ee), le) : N;
  }
  add(e, t) {
    return t.length ? this == N ? M.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, r) {
    let o, i = 0;
    e.forEach((l, a) => {
      let c = a + r, d;
      if (!!(d = wn(t, l, c))) {
        for (o || (o = this.children.slice()); i < o.length && o[i] < a; )
          i += 3;
        o[i] == a ? o[i + 2] = o[i + 2].addInner(l, d, c + 1) : o.splice(i, 0, a, a + l.nodeSize, Pe(d, l, c + 1, Z)), i += 3;
      }
    });
    let s = En(i ? Nn(t) : t, -r);
    for (let l = 0; l < s.length; l++)
      s[l].type.valid(e, s[l]) || s.splice(l--, 1);
    return new M(s.length ? this.local.concat(s).sort(ee) : this.local, o || this.children);
  }
  remove(e) {
    return e.length == 0 || this == N ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let r = this.children, o = this.local;
    for (let i = 0; i < r.length; i += 3) {
      let s, l = r[i] + t, a = r[i + 1] + t;
      for (let d = 0, h; d < e.length; d++)
        (h = e[d]) && h.from > l && h.to < a && (e[d] = null, (s || (s = [])).push(h));
      if (!s)
        continue;
      r == this.children && (r = this.children.slice());
      let c = r[i + 2].removeInner(s, l + 1);
      c != N ? r[i + 2] = c : (r.splice(i, 3), i -= 3);
    }
    if (o.length) {
      for (let i = 0, s; i < e.length; i++)
        if (s = e[i])
          for (let l = 0; l < o.length; l++)
            o[l].eq(s, t) && (o == this.local && (o = this.local.slice()), o.splice(l--, 1));
    }
    return r == this.children && o == this.local ? this : o.length || r.length ? new M(o, r) : N;
  }
  forChild(e, t) {
    if (this == N)
      return this;
    if (t.isLeaf)
      return M.empty;
    let r, o;
    for (let l = 0; l < this.children.length; l += 3)
      if (this.children[l] >= e) {
        this.children[l] == e && (r = this.children[l + 2]);
        break;
      }
    let i = e + 1, s = i + t.content.size;
    for (let l = 0; l < this.local.length; l++) {
      let a = this.local[l];
      if (a.from < s && a.to > i && a.type instanceof U) {
        let c = Math.max(i, a.from) - i, d = Math.min(s, a.to) - i;
        c < d && (o || (o = [])).push(a.copy(c, d));
      }
    }
    if (o) {
      let l = new M(o.sort(ee), le);
      return r ? new Y([l, r]) : l;
    }
    return r || N;
  }
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof M) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  locals(e) {
    return mt(this.localsInner(e));
  }
  localsInner(e) {
    if (this == N)
      return le;
    if (e.inlineContent || !this.local.some(U.is))
      return this.local;
    let t = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof U || t.push(this.local[r]);
    return t;
  }
}
M.empty = new M([], []);
M.removeOverlap = mt;
const N = M.empty;
class Y {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const r = this.members.map((o) => o.map(e, t, Z));
    return Y.from(r);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return M.empty;
    let r = [];
    for (let o = 0; o < this.members.length; o++) {
      let i = this.members[o].forChild(e, t);
      i != N && (i instanceof Y ? r = r.concat(i.members) : r.push(i));
    }
    return Y.from(r);
  }
  eq(e) {
    if (!(e instanceof Y) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, r = !0;
    for (let o = 0; o < this.members.length; o++) {
      let i = this.members[o].localsInner(e);
      if (!!i.length)
        if (!t)
          t = i;
        else {
          r && (t = t.slice(), r = !1);
          for (let s = 0; s < i.length; s++)
            t.push(i[s]);
        }
    }
    return t ? mt(r ? t : t.sort(ee)) : le;
  }
  static from(e) {
    switch (e.length) {
      case 0:
        return N;
      case 1:
        return e[0];
      default:
        return new Y(e.every((t) => t instanceof M) ? e : e.reduce((t, r) => t.concat(r instanceof M ? r : r.members), []));
    }
  }
}
function qr(n, e, t, r, o, i, s) {
  let l = n.slice();
  for (let c = 0, d = i; c < t.maps.length; c++) {
    let h = 0;
    t.maps[c].forEach((u, f, k, S) => {
      let C = S - k - (f - u);
      for (let w = 0; w < l.length; w += 3) {
        let B = l[w + 1];
        if (B < 0 || u > B + d - h)
          continue;
        let K = l[w] + d - h;
        f >= K ? l[w + 1] = u <= K ? -2 : -1 : k >= o && C && (l[w] += C, l[w + 1] += C);
      }
      h += C;
    }), d = t.maps[c].map(d, -1);
  }
  let a = !1;
  for (let c = 0; c < l.length; c += 3)
    if (l[c + 1] < 0) {
      if (l[c + 1] == -2) {
        a = !0, l[c + 1] = -1;
        continue;
      }
      let d = t.map(n[c] + i), h = d - o;
      if (h < 0 || h >= r.content.size) {
        a = !0;
        continue;
      }
      let u = t.map(n[c + 1] + i, -1), f = u - o, { index: k, offset: S } = r.content.findIndex(h), C = r.maybeChild(k);
      if (C && S == h && S + C.nodeSize == f) {
        let w = l[c + 2].mapInner(t, C, d + 1, n[c] + i + 1, s);
        w != N ? (l[c] = h, l[c + 1] = f, l[c + 2] = w) : (l[c + 1] = -2, a = !0);
      } else
        a = !0;
    }
  if (a) {
    let c = Ur(l, n, e, t, o, i, s), d = Pe(c, r, 0, s);
    e = d.local;
    for (let h = 0; h < l.length; h += 3)
      l[h + 1] < 0 && (l.splice(h, 3), h -= 3);
    for (let h = 0, u = 0; h < d.children.length; h += 3) {
      let f = d.children[h];
      for (; u < l.length && l[u] < f; )
        u += 3;
      l.splice(u, 0, d.children[h], d.children[h + 1], d.children[h + 2]);
    }
  }
  return new M(e.sort(ee), l);
}
function En(n, e) {
  if (!e || !n.length)
    return n;
  let t = [];
  for (let r = 0; r < n.length; r++) {
    let o = n[r];
    t.push(new I(o.from + e, o.to + e, o.type));
  }
  return t;
}
function Ur(n, e, t, r, o, i, s) {
  function l(a, c) {
    for (let d = 0; d < a.local.length; d++) {
      let h = a.local[d].map(r, o, c);
      h ? t.push(h) : s.onRemove && s.onRemove(a.local[d].spec);
    }
    for (let d = 0; d < a.children.length; d += 3)
      l(a.children[d + 2], a.children[d] + c + 1);
  }
  for (let a = 0; a < n.length; a += 3)
    n[a + 1] == -1 && l(n[a + 2], e[a] + i + 1);
  return t;
}
function wn(n, e, t) {
  if (e.isLeaf)
    return null;
  let r = t + e.nodeSize, o = null;
  for (let i = 0, s; i < n.length; i++)
    (s = n[i]) && s.from > t && s.to < r && ((o || (o = [])).push(s), n[i] = null);
  return o;
}
function Nn(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    n[t] != null && e.push(n[t]);
  return e;
}
function Pe(n, e, t, r) {
  let o = [], i = !1;
  e.forEach((l, a) => {
    let c = wn(n, l, a + t);
    if (c) {
      i = !0;
      let d = Pe(c, l, t + a + 1, r);
      d != N && o.push(a, a + l.nodeSize, d);
    }
  });
  let s = En(i ? Nn(n) : n, -t).sort(ee);
  for (let l = 0; l < s.length; l++)
    s[l].type.valid(e, s[l]) || (r.onRemove && r.onRemove(s[l].spec), s.splice(l--, 1));
  return s.length || o.length ? new M(s, o) : N;
}
function ee(n, e) {
  return n.from - e.from || n.to - e.to;
}
function mt(n) {
  let e = n;
  for (let t = 0; t < e.length - 1; t++) {
    let r = e[t];
    if (r.from != r.to)
      for (let o = t + 1; o < e.length; o++) {
        let i = e[o];
        if (i.from == r.from) {
          i.to != r.to && (e == n && (e = n.slice()), e[o] = i.copy(i.from, r.to), Jt(e, o + 1, i.copy(r.to, i.to)));
          continue;
        } else {
          i.from < r.to && (e == n && (e = n.slice()), e[t] = r.copy(r.from, i.from), Jt(e, o, r.copy(i.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function Jt(n, e, t) {
  for (; e < n.length && ee(t, n[e]) > 0; )
    e++;
  n.splice(e, 0, t);
}
const Vr = dt, qt = new L("previous-blocks"), Wr = {
  index: "index",
  level: "level",
  type: "type",
  depth: "depth",
  "depth-change": "depth-change"
}, Kr = () => new J({
  key: qt,
  view(n) {
    return {
      update: async (e, t) => {
        var r;
        ((r = this.key) == null ? void 0 : r.getState(e.state).updatedBlocks.size) > 0 && setTimeout(() => {
          e.dispatch(
            e.state.tr.setMeta(qt, { clearUpdate: !0 })
          );
        }, 0);
      }
    };
  },
  state: {
    init() {
      return {
        prevTransactionOldBlockAttrs: {},
        currentTransactionOldBlockAttrs: {},
        updatedBlocks: /* @__PURE__ */ new Set()
      };
    },
    apply(n, e, t, r) {
      if (e.currentTransactionOldBlockAttrs = {}, e.updatedBlocks.clear(), !n.docChanged || t.doc.eq(r.doc))
        return e;
      const o = {}, i = Ke(t.doc, (a) => a.attrs.id), s = new Map(
        i.map((a) => [a.node.attrs.id, a])
      ), l = Ke(r.doc, (a) => a.attrs.id);
      for (let a of l) {
        const c = s.get(a.node.attrs.id), d = c == null ? void 0 : c.node.firstChild, h = a.node.firstChild;
        if (c && d && h) {
          const u = {
            index: h.attrs.index,
            level: h.attrs.level,
            type: h.type.name,
            depth: r.doc.resolve(a.pos).depth
          };
          let f = {
            index: d.attrs.index,
            level: d.attrs.level,
            type: d.type.name,
            depth: t.doc.resolve(c.pos).depth
          };
          o[a.node.attrs.id] = f, n.getMeta("numberedListIndexing") && (a.node.attrs.id in e.prevTransactionOldBlockAttrs && (f = e.prevTransactionOldBlockAttrs[a.node.attrs.id]), u.type === "numberedListItem" && (f.index = u.index)), e.currentTransactionOldBlockAttrs[a.node.attrs.id] = f, JSON.stringify(f) !== JSON.stringify(u) && (f["depth-change"] = f.depth - u.depth, e.updatedBlocks.add(a.node.attrs.id));
        }
      }
      return e.prevTransactionOldBlockAttrs = o, e;
    }
  },
  props: {
    decorations(n) {
      const e = this.getState(n);
      if (e.updatedBlocks.size === 0)
        return;
      const t = [];
      return n.doc.descendants((r, o) => {
        if (!r.attrs.id || !e.updatedBlocks.has(r.attrs.id))
          return;
        const i = e.currentTransactionOldBlockAttrs[r.attrs.id], s = {};
        for (let [a, c] of Object.entries(i))
          s["data-prev-" + Wr[a]] = c || "none";
        const l = I.node(o, o + r.nodeSize, {
          ...s
        });
        t.push(l);
      }), M.create(n.doc, t);
    }
  }
}), Gr = "_blockOuter_1ltqa_5", Yr = "_block_1ltqa_5", _r = "_blockContent_1ltqa_19", Xr = "_blockGroup_1ltqa_47", jr = "_isEmpty_1ltqa_232", Qr = "_isFilter_1ltqa_233", Zr = "_hasAnchor_1ltqa_246", F = {
  blockOuter: Gr,
  block: Yr,
  blockContent: _r,
  blockGroup: Xr,
  isEmpty: jr,
  isFilter: Qr,
  hasAnchor: Zr
}, eo = {
  blockColor: "data-block-color",
  blockStyle: "data-block-style",
  id: "data-id",
  depth: "data-depth",
  depthChange: "data-depth-change"
}, to = re.create({
  name: "blockContainer",
  group: "blockContainer",
  content: "blockContent blockGroup?",
  priority: 50,
  defining: !0,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "div",
        getAttrs: (n) => {
          if (typeof n == "string")
            return !1;
          const e = {};
          for (let [t, r] of Object.entries(eo))
            n.getAttribute(r) && (e[t] = n.getAttribute(r));
          return n.getAttribute("data-node-type") === "blockContainer" ? e : !1;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return [
      "div",
      ne(n, {
        class: F.blockOuter,
        "data-node-type": "block-outer"
      }),
      [
        "div",
        ne(n, {
          class: F.block,
          "data-node-type": this.name
        }),
        0
      ]
    ];
  },
  addCommands() {
    return {
      BNCreateBlock: (n) => ({ state: e, dispatch: t }) => {
        const r = e.schema.nodes.blockContainer.createAndFill();
        return t && e.tr.insert(n, r), !0;
      },
      BNDeleteBlock: (n) => ({ state: e, view: t, dispatch: r }) => {
        const o = T(e.doc, n);
        if (o === void 0)
          return !1;
        const { startPos: i, endPos: s } = o;
        return r && (e.tr.deleteRange(i, s), e.tr.setSelection(
          new x(e.doc.resolve(i + 1))
        ), t.focus()), !0;
      },
      BNMergeBlocks: (n) => ({ state: e, dispatch: t }) => {
        const r = e.doc.resolve(n + 1).node().type.name === "blockContainer", o = e.doc.resolve(n - 1).node().type.name === "blockContainer";
        if (!r || !o)
          return !1;
        const i = T(
          e.doc,
          n + 1
        ), { node: s, contentNode: l, startPos: a, endPos: c, depth: d } = i;
        if (s.childCount === 2) {
          const f = e.doc.resolve(
            a + l.nodeSize + 1
          ), k = e.doc.resolve(c - 1), S = f.blockRange(k);
          t && e.tr.lift(S, d - 1);
        }
        let h = n - 1, u = T(e.doc, h);
        for (; u.numChildBlocks > 0; )
          if (h--, u = T(e.doc, h), u === void 0)
            return !1;
        return t && (e.tr.deleteRange(a, a + l.nodeSize), e.tr.insertText(l.textContent, h - 1), e.tr.setSelection(
          new x(e.doc.resolve(h - 1))
        )), !0;
      },
      BNSplitBlock: (n, e) => ({ state: t, dispatch: r }) => {
        const o = T(t.doc, n);
        if (o === void 0)
          return !1;
        const { contentNode: i, contentType: s, startPos: l, endPos: a, depth: c } = o, d = t.doc.cut(l + 1, n), h = t.doc.cut(n, a - 1), u = t.schema.nodes.blockContainer.createAndFill(), f = a + 1, k = f + 2;
        return r && (t.tr.insert(f, u), t.tr.replace(
          k,
          k + 1,
          h.content.size > 0 ? new p(
            g.from(h),
            c + 2,
            c + 2
          ) : void 0
        ), e && t.tr.setBlockType(
          k,
          k,
          t.schema.node(s).type,
          i.attrs
        ), t.tr.setSelection(
          new x(t.doc.resolve(k))
        ), t.tr.replace(
          l + 1,
          a - 1,
          d.content.size > 0 ? new p(
            g.from(d),
            c + 2,
            c + 2
          ) : void 0
        )), !0;
      },
      BNUpdateBlock: (n, e) => ({ state: t, dispatch: r }) => {
        const o = T(t.doc, n);
        if (o === void 0)
          return !1;
        const { node: i, startPos: s, contentNode: l } = o;
        return r && t.tr.setBlockType(
          s + 1,
          s + l.nodeSize + 1,
          t.schema.node(e.type).type,
          {
            ...i.attrs,
            ...e.props
          }
        ), !0;
      },
      BNCreateOrUpdateBlock: (n, e) => ({ state: t, chain: r }) => {
        const o = T(t.doc, n);
        if (o === void 0)
          return !1;
        const { node: i, startPos: s, endPos: l } = o;
        if (i.textContent.length === 0) {
          const a = s + 1;
          return r().BNUpdateBlock(n, e).setTextSelection(a).run();
        } else {
          const a = l + 1, c = a + 1;
          return r().BNCreateBlock(a).BNUpdateBlock(c, e).setTextSelection(c).run();
        }
      }
    };
  },
  addProseMirrorPlugins() {
    return [Kr()];
  },
  addKeyboardShortcuts() {
    return {
      Backspace: () => this.editor.commands.first(({ commands: t }) => [
        () => t.deleteSelection(),
        () => t.undoInputRule(),
        () => t.command(({ state: r }) => {
          const { contentType: o } = T(
            r.doc,
            r.selection.from
          ), i = r.selection.$anchor.parentOffset === 0, s = o.name === "paragraph";
          return i && !s ? t.BNUpdateBlock(r.selection.from, {
            type: "paragraph",
            props: {}
          }) : !1;
        }),
        () => t.command(({ state: r }) => r.selection.$anchor.parentOffset === 0 ? t.liftListItem("blockContainer") : !1),
        () => t.command(({ state: r }) => {
          const { depth: o, startPos: i } = T(
            r.doc,
            r.selection.from
          ), s = r.selection.$anchor.parentOffset === 0, l = r.selection.anchor === r.selection.head, a = i === 2, c = i - 1;
          return !a && s && l && o === 2 ? t.BNMergeBlocks(c) : !1;
        })
      ]),
      Enter: () => this.editor.commands.first(({ commands: t }) => [
        () => t.command(({ state: r }) => {
          const { node: o, depth: i } = T(
            r.doc,
            r.selection.from
          ), s = r.selection.$anchor.parentOffset === 0, l = r.selection.anchor === r.selection.head, a = o.textContent.length === 0, c = i > 2;
          return s && l && a && c ? t.liftListItem("blockContainer") : !1;
        }),
        () => t.command(({ state: r, chain: o }) => {
          const { node: i, endPos: s } = T(
            r.doc,
            r.selection.from
          ), l = r.selection.$anchor.parentOffset === 0, a = r.selection.anchor === r.selection.head, c = i.textContent.length === 0;
          if (l && a && c) {
            const d = s + 1, h = d + 2;
            return o().BNCreateBlock(d).setTextSelection(h).run(), !0;
          }
          return !1;
        }),
        () => t.command(({ state: r, chain: o }) => {
          const { node: i } = T(
            r.doc,
            r.selection.from
          );
          return i.textContent.length === 0 ? !1 : (o().deleteSelection().BNSplitBlock(r.selection.from, !1).run(), !0);
        })
      ]),
      Tab: () => (this.editor.commands.sinkListItem("blockContainer"), !0),
      "Shift-Tab": () => (this.editor.commands.liftListItem("blockContainer"), !0),
      "Mod-Alt-0": () => this.editor.commands.BNCreateBlock(
        this.editor.state.selection.anchor + 2
      ),
      "Mod-Alt-1": () => this.editor.commands.BNUpdateBlock(this.editor.state.selection.anchor, {
        type: "heading",
        props: {
          level: "1"
        }
      }),
      "Mod-Alt-2": () => this.editor.commands.BNUpdateBlock(this.editor.state.selection.anchor, {
        type: "heading",
        props: {
          level: "2"
        }
      }),
      "Mod-Alt-3": () => this.editor.commands.BNUpdateBlock(this.editor.state.selection.anchor, {
        type: "heading",
        props: {
          level: "3"
        }
      }),
      "Mod-Shift-7": () => this.editor.commands.BNUpdateBlock(this.editor.state.selection.anchor, {
        type: "bulletListItem",
        props: {}
      }),
      "Mod-Shift-8": () => this.editor.commands.BNUpdateBlock(this.editor.state.selection.anchor, {
        type: "numberedListItem",
        props: {}
      })
    };
  }
}), no = re.create({
  name: "blockGroup",
  group: "blockGroup",
  content: "blockContainer+",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "div",
        getAttrs: (n) => typeof n == "string" ? !1 : n.getAttribute("data-node-type") === "blockGroup" ? null : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return [
      "div",
      ne(this.options.HTMLAttributes, n, {
        class: F.blockGroup,
        "data-node-type": "blockGroup"
      }),
      0
    ];
  }
}), ro = re.create({
  name: "paragraph",
  group: "blockContent",
  content: "inline*",
  parseHTML() {
    return [
      {
        tag: "p",
        priority: 200,
        node: "blockContainer"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return [
      "div",
      ne(n, {
        class: F.blockContent,
        "data-content-type": this.name
      }),
      ["p", 0]
    ];
  }
}), oo = re.create({
  name: "heading",
  group: "blockContent",
  content: "inline*",
  addAttributes() {
    return {
      level: {
        default: "1",
        parseHTML: (n) => n.getAttribute("data-level"),
        renderHTML: (n) => ({
          "data-level": n.level
        })
      }
    };
  },
  addInputRules() {
    return [
      ...["1", "2", "3"].map((n) => new ot({
        find: new RegExp(`^(#{${parseInt(n)}})\\s$`),
        handler: ({ state: e, chain: t, range: r }) => {
          t().BNUpdateBlock(e.selection.from, {
            type: "heading",
            props: {
              level: n
            }
          }).deleteRange({ from: r.from, to: r.to });
        }
      }))
    ];
  },
  parseHTML() {
    return [
      {
        tag: "h1",
        attrs: { level: "1" },
        node: "blockContainer"
      },
      {
        tag: "h2",
        attrs: { level: "2" },
        node: "blockContainer"
      },
      {
        tag: "h3",
        attrs: { level: "3" },
        node: "blockContainer"
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "div",
      ne(e, {
        class: F.blockContent,
        "data-content-type": this.name
      }),
      ["h" + n.attrs.level, 0]
    ];
  }
}), vn = (n) => {
  const { node: e, contentType: t } = T(
    n.state.doc,
    n.state.selection.from
  ), r = n.state.selection.anchor === n.state.selection.head;
  return !t.name.endsWith("ListItem") || !r ? !1 : n.commands.first(({ state: o, chain: i, commands: s }) => [
    () => s.command(() => e.textContent.length === 0 ? s.BNUpdateBlock(o.selection.from, {
      type: "paragraph",
      props: {}
    }) : !1),
    () => s.command(() => e.textContent.length > 0 ? (i().deleteSelection().BNSplitBlock(o.selection.from, !0).run(), !0) : !1)
  ]);
}, io = re.create({
  name: "bulletListItem",
  group: "blockContent",
  content: "inline*",
  addInputRules() {
    return [
      new ot({
        find: new RegExp("^[-+*]\\s$"),
        handler: ({ state: n, chain: e, range: t }) => {
          e().BNUpdateBlock(n.selection.from, {
            type: "bulletListItem",
            props: {}
          }).deleteRange({ from: t.from, to: t.to });
        }
      })
    ];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => vn(this.editor)
    };
  },
  parseHTML() {
    return [
      {
        tag: "li",
        getAttrs: (n) => {
          if (typeof n == "string")
            return !1;
          const e = n.parentElement;
          return e === null ? !1 : e.getAttribute("data-content-type") === "bulletListItem" ? {} : e.tagName === "UL" ? {} : !1;
        },
        node: "blockContainer"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return [
      "div",
      ne(n, {
        class: F.blockContent,
        "data-content-type": this.name
      }),
      ["li", 0]
    ];
  }
}), so = new L("numbered-list-indexing"), lo = () => new J({
  key: so,
  appendTransaction: (n, e, t) => {
    const r = t.tr;
    r.setMeta("numberedListIndexing", !0);
    let o = !1;
    return t.doc.descendants((i, s) => {
      if (i.type.name === "blockContainer" && i.firstChild.type.name === "numberedListItem") {
        let l = "1";
        const a = s === 1, c = T(r.doc, s + 1);
        if (c === void 0)
          return;
        if (!a) {
          const u = T(r.doc, s - 2);
          if (u === void 0)
            return;
          if (!(c.depth !== u.depth)) {
            const k = u.contentNode;
            if (u.contentType.name === "numberedListItem") {
              const w = k.attrs.index;
              l = (parseInt(w) + 1).toString();
            }
          }
        }
        c.contentNode.attrs.index !== l && (o = !0, r.setNodeMarkup(s + 1, void 0, {
          index: l
        }));
      }
    }), o ? r : null;
  }
}), ao = re.create({
  name: "numberedListItem",
  group: "blockContent",
  content: "inline*",
  addAttributes() {
    return {
      index: {
        default: null,
        parseHTML: (n) => n.getAttribute("data-index"),
        renderHTML: (n) => ({
          "data-index": n.index
        })
      }
    };
  },
  addInputRules() {
    return [
      new ot({
        find: new RegExp("^1\\.\\s$"),
        handler: ({ state: n, chain: e, range: t }) => {
          e().BNUpdateBlock(n.selection.from, {
            type: "numberedListItem",
            props: {}
          }).deleteRange({ from: t.from, to: t.to });
        }
      })
    ];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => vn(this.editor)
    };
  },
  addProseMirrorPlugins() {
    return [lo()];
  },
  parseHTML() {
    return [
      {
        tag: "li",
        getAttrs: (n) => {
          if (typeof n == "string")
            return !1;
          const e = n.parentElement;
          return e === null ? !1 : e.getAttribute("data-content-type") === "numberedListItem" ? {} : e.tagName === "OL" ? {} : !1;
        },
        node: "blockContainer"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return [
      "div",
      ne(n, {
        class: F.blockContent,
        "data-content-type": this.name
      }),
      ["li", 0]
    ];
  }
}), co = [
  ro,
  oo,
  io,
  ao,
  to,
  no,
  re.create({
    name: "doc",
    topNode: !0,
    content: "blockGroup"
  })
];
class ho {
  constructor({
    editor: e,
    formattingToolbarFactory: t,
    view: r,
    shouldShow: o
  }) {
    m(this, "editor");
    m(this, "view");
    m(this, "formattingToolbar");
    m(this, "preventHide", !1);
    m(this, "preventShow", !1);
    m(this, "toolbarIsOpen", !1);
    m(this, "shouldShow", ({ view: e, state: t, from: r, to: o }) => {
      const { doc: i, selection: s } = t, { empty: l } = s, a = !i.textBetween(r, o).length && Pn(t.selection);
      return !(!e.hasFocus() || l || a);
    });
    m(this, "viewMousedownHandler", () => {
      this.preventShow = !0;
    });
    m(this, "viewMouseupHandler", () => {
      this.preventShow = !1, setTimeout(() => this.update(this.editor.view));
    });
    m(this, "dragstartHandler", () => {
      this.formattingToolbar.hide(), this.toolbarIsOpen = !1;
    });
    m(this, "focusHandler", () => {
      setTimeout(() => this.update(this.editor.view));
    });
    m(this, "blurHandler", ({ event: e }) => {
      var t, r;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      (e == null ? void 0 : e.relatedTarget) && ((r = (t = this.formattingToolbar.element) == null ? void 0 : t.parentNode) == null ? void 0 : r.contains(
        e.relatedTarget
      )) || this.toolbarIsOpen && (this.formattingToolbar.hide(), this.toolbarIsOpen = !1);
    });
    this.editor = e, this.view = r, this.formattingToolbar = t(this.getStaticParams()), o && (this.shouldShow = o), this.view.dom.addEventListener("mousedown", this.viewMousedownHandler), this.view.dom.addEventListener("mouseup", this.viewMouseupHandler), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler);
  }
  update(e, t) {
    var u;
    const { state: r, composing: o } = e, { doc: i, selection: s } = r, l = t && t.doc.eq(i) && t.selection.eq(s);
    if (o || l)
      return;
    const { ranges: a } = s, c = Math.min(...a.map((f) => f.$from.pos)), d = Math.max(...a.map((f) => f.$to.pos)), h = (u = this.shouldShow) == null ? void 0 : u.call(this, {
      editor: this.editor,
      view: e,
      state: r,
      oldState: t,
      from: c,
      to: d
    });
    if (!this.toolbarIsOpen && !this.preventShow && (h || this.preventHide)) {
      this.formattingToolbar.render(this.getDynamicParams(), !0), this.toolbarIsOpen = !0, this.formattingToolbar.element.addEventListener(
        "mousedown",
        (f) => f.preventDefault()
      );
      return;
    }
    if (this.toolbarIsOpen && !this.preventShow && (h || this.preventHide)) {
      this.formattingToolbar.render(this.getDynamicParams(), !1);
      return;
    }
    if (this.toolbarIsOpen && !this.preventHide && (!h || this.preventShow)) {
      this.formattingToolbar.hide(), this.toolbarIsOpen = !1, this.formattingToolbar.element.removeEventListener(
        "mousedown",
        (f) => f.preventDefault()
      );
      return;
    }
  }
  destroy() {
    this.view.dom.removeEventListener("mousedown", this.viewMousedownHandler), this.view.dom.removeEventListener("mouseup", this.viewMouseupHandler), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
  getSelectionBoundingBox() {
    const { state: e } = this.editor.view, { selection: t } = e, { ranges: r } = t, o = Math.min(...r.map((s) => s.$from.pos)), i = Math.max(...r.map((s) => s.$to.pos));
    if (Dn(t)) {
      const s = this.editor.view.nodeDOM(o);
      if (s)
        return s.getBoundingClientRect();
    }
    return Vt(this.editor.view, o, i);
  }
  getStaticParams() {
    return {
      toggleBold: () => {
        this.editor.view.focus(), this.editor.commands.toggleBold();
      },
      toggleItalic: () => {
        this.editor.view.focus(), this.editor.commands.toggleItalic();
      },
      toggleUnderline: () => {
        this.editor.view.focus(), this.editor.commands.toggleUnderline();
      },
      toggleStrike: () => {
        this.editor.view.focus(), this.editor.commands.toggleStrike();
      },
      setHyperlink: (e, t) => {
        if (e === "")
          return;
        let { from: r, to: o } = this.editor.state.selection;
        t || (t = this.editor.state.doc.textBetween(r, o));
        const i = this.editor.schema.mark("link", { href: e });
        this.editor.view.dispatch(
          this.editor.view.state.tr.insertText(t, r, o).addMark(r, r + t.length, i)
        ), this.editor.view.focus();
      },
      setTextColor: (e) => {
        this.editor.view.focus(), this.editor.commands.setTextColor(e);
      },
      setBackgroundColor: (e) => {
        this.editor.view.focus(), this.editor.commands.setBackgroundColor(e);
      },
      setTextAlignment: (e) => {
        this.editor.view.focus(), this.editor.commands.setTextAlignment(e);
      },
      increaseBlockIndent: () => {
        this.editor.view.focus(), this.editor.commands.sinkListItem("blockContainer");
      },
      decreaseBlockIndent: () => {
        this.editor.view.focus(), this.editor.commands.liftListItem("blockContainer");
      },
      updateBlock: (e) => {
        this.editor.view.focus(), this.editor.commands.BNUpdateBlock(
          this.editor.state.selection.from,
          e
        );
      }
    };
  }
  getDynamicParams() {
    const e = T(
      this.editor.state.doc,
      this.editor.state.selection.from
    );
    return {
      boldIsActive: this.editor.isActive("bold"),
      italicIsActive: this.editor.isActive("italic"),
      underlineIsActive: this.editor.isActive("underline"),
      strikeIsActive: this.editor.isActive("strike"),
      hyperlinkIsActive: this.editor.isActive("link"),
      activeHyperlinkUrl: this.editor.getAttributes("link").href || "",
      activeHyperlinkText: this.editor.state.doc.textBetween(
        this.editor.state.selection.from,
        this.editor.state.selection.to
      ),
      textColor: this.editor.getAttributes("textColor").color || "default",
      backgroundColor: this.editor.getAttributes("backgroundColor").color || "default",
      textAlignment: this.editor.getAttributes(e.contentType).textAlignment || "left",
      canIncreaseBlockIndent: this.editor.state.doc.resolve(e.startPos).index(e.depth - 1) > 0,
      canDecreaseBlockIndent: e.depth > 2,
      block: {
        type: e.contentType.name,
        props: e.contentNode.attrs
      },
      referenceRect: this.getSelectionBoundingBox()
    };
  }
}
const uo = (n) => new J({
  key: new L("FormattingToolbarPlugin"),
  view: (e) => new ho({ view: e, ...n })
}), fo = $.create({
  name: "FormattingToolbarExtension",
  addProseMirrorPlugins() {
    if (!this.options.formattingToolbarFactory)
      throw new Error(
        "UI Element factory not defined for FormattingToolbarExtension"
      );
    return [
      uo({
        editor: this.editor,
        formattingToolbarFactory: this.options.formattingToolbarFactory,
        pluginKey: new L("FormattingToolbarPlugin")
      })
    ];
  }
}), po = "_bnEditor_xixap_3", mo = "_bnRoot_xixap_13", go = "_dragPreview_xixap_27", nt = {
  bnEditor: po,
  bnRoot: mo,
  dragPreview: go
}, ko = Rn(
  (n) => n.type.name === "blockContainer"
);
function rt() {
  return {
    active: !1,
    triggerCharacter: void 0,
    queryStartPos: void 0,
    items: [],
    keyboardHoveredItemIndex: void 0,
    notFoundCount: 0,
    decorationId: void 0
  };
}
class yo {
  constructor({
    editor: e,
    pluginKey: t,
    onSelectItem: r = () => {
    },
    suggestionsMenuFactory: o
  }) {
    m(this, "editor");
    m(this, "pluginKey");
    m(this, "suggestionsMenu");
    m(this, "pluginState");
    m(this, "itemCallback");
    this.editor = e, this.pluginKey = t, this.pluginState = rt(), this.itemCallback = (i) => r({
      item: i,
      editor: e,
      range: {
        from: this.pluginState.queryStartPos - this.pluginState.triggerCharacter.length,
        to: e.state.selection.from
      }
    }), this.suggestionsMenu = o(this.getStaticParams());
  }
  update(e, t) {
    const r = this.pluginKey.getState(t), o = this.pluginKey.getState(e.state), i = !r.active && o.active, s = r.active && !o.active, l = r.active && o.active;
    !i && !l && !s || (this.pluginState = s ? r : o, s && (this.suggestionsMenu.hide(), this.suggestionsMenu.element.removeEventListener(
      "mousedown",
      (a) => a.preventDefault()
    )), l && this.suggestionsMenu.render(this.getDynamicParams(), !1), i && (this.suggestionsMenu.render(this.getDynamicParams(), !0), this.suggestionsMenu.element.addEventListener(
      "mousedown",
      (a) => a.preventDefault()
    )));
  }
  getStaticParams() {
    return {
      itemCallback: (e) => this.itemCallback(e)
    };
  }
  getDynamicParams() {
    const e = document.querySelector(
      `[data-decoration-id="${this.pluginState.decorationId}"]`
    );
    return {
      items: this.pluginState.items,
      keyboardHoveredItemIndex: this.pluginState.keyboardHoveredItemIndex,
      referenceRect: e.getBoundingClientRect()
    };
  }
}
function bo({
  pluginKey: n,
  editor: e,
  defaultTriggerCharacter: t,
  suggestionsMenuFactory: r,
  onSelectItem: o = () => {
  },
  items: i = () => []
}) {
  if (t.length !== 1)
    throw new Error("'char' should be a single character");
  const s = (l) => {
    l.dispatch(l.state.tr.setMeta(n, { deactivate: !0 }));
  };
  return new J({
    key: n,
    view: (l) => new yo({
      editor: e,
      pluginKey: n,
      onSelectItem: (a) => {
        s(l), o(a);
      },
      suggestionsMenuFactory: r
    }),
    state: {
      init() {
        return rt();
      },
      apply(l, a, c, d) {
        var u, f, k, S;
        if (l.getMeta("orderedListIndexing") !== void 0)
          return a;
        if ((u = l.getMeta(n)) != null && u.activate)
          return {
            active: !0,
            triggerCharacter: ((f = l.getMeta(n)) == null ? void 0 : f.triggerCharacter) || "",
            queryStartPos: d.selection.from,
            items: i(""),
            keyboardHoveredItemIndex: 0,
            notFoundCount: 0,
            decorationId: `id_${Math.floor(Math.random() * 4294967295)}`
          };
        if (!a.active)
          return a;
        const h = { ...a };
        if (h.items = i(
          d.doc.textBetween(a.queryStartPos, d.selection.from)
        ), h.notFoundCount = 0, h.items.length === 0 && (h.notFoundCount = Math.max(
          0,
          a.notFoundCount + (d.selection.from - c.selection.from)
        )), d.selection.from !== d.selection.to || ((k = l.getMeta(n)) == null ? void 0 : k.deactivate) || l.getMeta("focus") || l.getMeta("blur") || l.getMeta("pointer") || a.active && d.selection.from < a.queryStartPos || h.notFoundCount > 3)
          return rt();
        if (((S = l.getMeta(n)) == null ? void 0 : S.selectedItemIndexChanged) !== void 0) {
          let C = l.getMeta(n).selectedItemIndexChanged;
          C < 0 ? C = a.items.length - 1 : C >= a.items.length && (C = 0), h.keyboardHoveredItemIndex = C;
        }
        return h;
      }
    },
    props: {
      handleKeyDown(l, a) {
        const c = this.getState(l.state).active;
        if (a.key === t && !c)
          return l.dispatch(
            l.state.tr.insertText(t).scrollIntoView().setMeta(n, {
              activate: !0,
              triggerCharacter: t
            })
          ), !0;
        if (!c)
          return !1;
        const {
          triggerCharacter: d,
          queryStartPos: h,
          items: u,
          keyboardHoveredItemIndex: f
        } = n.getState(l.state);
        return a.key === "ArrowUp" ? (l.dispatch(
          l.state.tr.setMeta(n, {
            selectedItemIndexChanged: f - 1
          })
        ), !0) : a.key === "ArrowDown" ? (l.dispatch(
          l.state.tr.setMeta(n, {
            selectedItemIndexChanged: f + 1
          })
        ), !0) : a.key === "Enter" ? (s(l), o({
          item: u[f],
          editor: e,
          range: {
            from: h - d.length,
            to: l.state.selection.from
          }
        }), !0) : a.key === "Escape" ? (s(l), !0) : !1;
      },
      handleClick(l) {
        s(l);
      },
      decorations(l) {
        const { active: a, decorationId: c, queryStartPos: d, triggerCharacter: h } = this.getState(l);
        if (!a)
          return null;
        if (h === "") {
          const u = ko(l.selection);
          if (u)
            return M.create(l.doc, [
              I.node(
                u.pos,
                u.pos + u.node.nodeSize,
                {
                  nodeName: "span",
                  class: "suggestion-decorator",
                  "data-decoration-id": c
                }
              )
            ]);
        }
        return M.create(l.doc, [
          I.inline(
            d - h.length,
            d,
            {
              nodeName: "span",
              class: "suggestion-decorator",
              "data-decoration-id": c
            }
          )
        ]);
      }
    }
  });
}
class ie {
  constructor(e, t, r = []) {
    this.name = e, this.execute = t, this.aliases = r;
  }
  match(e) {
    return this.name.toLowerCase().startsWith(e.toLowerCase()) || this.aliases.filter(
      (t) => t.toLowerCase().startsWith(e.toLowerCase())
    ).length !== 0;
  }
}
const Co = {
  heading: new ie(
    "Heading",
    (n, e) => n.chain().focus().deleteRange(e).BNCreateOrUpdateBlock(e.from, {
      type: "heading",
      props: {
        level: "1"
      }
    }).run(),
    ["h", "heading1", "h1"]
  ),
  heading2: new ie(
    "Heading 2",
    (n, e) => n.chain().focus().deleteRange(e).BNCreateOrUpdateBlock(e.from, {
      type: "heading",
      props: {
        level: "2"
      }
    }).run(),
    ["h2", "heading2", "subheading"]
  ),
  heading3: new ie(
    "Heading 3",
    (n, e) => n.chain().focus().deleteRange(e).BNCreateOrUpdateBlock(e.from, {
      type: "heading",
      props: {
        level: "3"
      }
    }).run(),
    ["h3", "heading3", "subheading"]
  ),
  numberedList: new ie(
    "Numbered List",
    (n, e) => n.chain().focus().deleteRange(e).BNCreateOrUpdateBlock(e.from, {
      type: "numberedListItem",
      props: {}
    }).run(),
    ["li", "list", "numberedlist", "numbered list"]
  ),
  bulletList: new ie(
    "Bullet List",
    (n, e) => n.chain().focus().deleteRange(e).BNCreateOrUpdateBlock(e.from, {
      type: "bulletListItem",
      props: {}
    }).run(),
    ["ul", "list", "bulletlist", "bullet list"]
  ),
  paragraph: new ie(
    "Paragraph",
    (n, e) => n.chain().focus().deleteRange(e).BNCreateOrUpdateBlock(e.from, {
      type: "paragraph",
      props: {}
    }).run(),
    ["p"]
  )
}, gt = new L("suggestions-slash-commands"), So = $.create({
  name: "slash-command",
  addOptions() {
    return {
      commands: Co,
      slashMenuFactory: void 0
    };
  },
  addProseMirrorPlugins() {
    if (!this.options.slashMenuFactory)
      throw new Error("UI Element factory not defined for SlashMenuExtension");
    return [
      bo({
        pluginKey: gt,
        editor: this.editor,
        defaultTriggerCharacter: "/",
        suggestionsMenuFactory: this.options.slashMenuFactory,
        items: (n) => {
          const e = [];
          for (const t in this.options.commands)
            e.push(this.options.commands[t]);
          return e.filter((t) => t.match(n));
        },
        onSelectItem: ({ item: n, editor: e, range: t }) => {
          n.execute(e, t);
        }
      })
    ];
  }
});
class ge extends b {
  constructor(t, r) {
    super(t, r);
    m(this, "nodes");
    const o = t.node();
    this.nodes = [], t.doc.nodesBetween(t.pos, r.pos, (i, s, l) => {
      if (l !== null && l.eq(o))
        return this.nodes.push(i), !1;
    });
  }
  static create(t, r, o = r) {
    return new ge(t.resolve(r), t.resolve(o));
  }
  content() {
    return new p(g.from(this.nodes), 0, 0);
  }
  eq(t) {
    if (!(t instanceof ge) || this.nodes.length !== t.nodes.length || this.from !== t.from || this.to !== t.to)
      return !1;
    for (let r = 0; r < this.nodes.length; r++)
      if (!this.nodes[r].eq(t.nodes[r]))
        return !1;
    return !0;
  }
  map(t, r) {
    let o = r.mapResult(this.from), i = r.mapResult(this.to);
    return i.deleted ? b.near(t.resolve(o.pos)) : o.deleted ? b.near(t.resolve(i.pos)) : new ge(
      t.resolve(o.pos),
      t.resolve(i.pos)
    );
  }
  toJSON() {
    return { type: "node", anchor: this.anchor, head: this.head };
  }
}
const xo = Vr;
let te;
function Bn(n, e) {
  var o;
  let t = e.posAtCoords(n);
  if (!t)
    return;
  let r = e.domAtPos(t.pos).node;
  if (r !== e.dom) {
    for (; r && r.parentNode && r.parentNode !== e.dom && !((o = r.hasAttribute) != null && o.call(r, "data-id")); )
      r = r.parentNode;
    if (!!r)
      return { node: r, id: r.getAttribute("data-id") };
  }
}
function Mo(n, e) {
  let t = Bn(n, e);
  if (t && t.node.nodeType === 1) {
    const r = e.docView;
    let o = r.nearestDesc(t.node, !0);
    return !o || o === r ? null : o.posBefore;
  }
  return null;
}
function To(n, e) {
  let t, r;
  const o = e.resolve(n.from).node().type.spec.group === "blockContent", i = e.resolve(n.to).node().type.spec.group === "blockContent", s = Math.min(n.$anchor.depth, n.$head.depth);
  if (o && i) {
    const l = n.$from.start(s - 1), a = n.$to.end(s - 1);
    t = e.resolve(l - 1).pos, r = e.resolve(a + 1).pos;
  } else
    t = n.from, r = n.to;
  return { from: t, to: r };
}
function Ut(n, e, t = e) {
  e === t && (t += n.state.doc.resolve(e + 1).node().nodeSize);
  const r = n.domAtPos(e).node.cloneNode(!0), o = n.domAtPos(e).node, i = (a, c) => Array.prototype.indexOf.call(a.children, c), s = i(
    o,
    n.domAtPos(e + 1).node.parentElement
  ), l = i(
    o,
    n.domAtPos(t - 1).node.parentElement
  );
  for (let a = o.childElementCount - 1; a >= 0; a--)
    (a > l || a < s) && r.removeChild(r.children[a]);
  te = r, te.className = nt.dragPreview, document.body.appendChild(te);
}
function Eo() {
  te !== void 0 && (document.body.removeChild(te), te = void 0);
}
function wo(n, e) {
  if (!n.dataTransfer)
    return;
  const t = e.dom.getBoundingClientRect();
  let r = {
    left: t.left + t.width / 2,
    top: n.clientY
  }, o = Mo(r, e);
  if (o != null) {
    const i = e.state.selection, s = e.state.doc, { from: l, to: a } = To(i, s), c = l <= o && o < a, d = !i.$anchor.node().eq(i.$head.node());
    c && d ? (e.dispatch(
      e.state.tr.setSelection(ge.create(s, l, a))
    ), Ut(e, l, a)) : (e.dispatch(
      e.state.tr.setSelection(y.create(e.state.doc, o))
    ), Ut(e, o));
    let h = e.state.selection.content(), { dom: u, text: f } = xo(e, h);
    n.dataTransfer.clearData(), n.dataTransfer.setData("text/html", u.innerHTML), n.dataTransfer.setData("text/plain", f), n.dataTransfer.effectAllowed = "move", n.dataTransfer.setDragImage(te, 0, 0), e.dragging = { slice: h, move: !0 };
  }
}
class No {
  constructor({
    editor: e,
    blockMenuFactory: t,
    horizontalPosAnchoredAtRoot: r
  }) {
    m(this, "editor");
    m(this, "horizontalPosAnchoredAtRoot");
    m(this, "horizontalPosAnchor");
    m(this, "blockMenu");
    m(this, "hoveredBlockContent");
    m(this, "menuOpen", !1);
    m(this, "menuFrozen", !1);
    this.editor = e, this.horizontalPosAnchoredAtRoot = r, this.horizontalPosAnchor = e.view.dom.firstChild.getBoundingClientRect().x, this.blockMenu = t(this.getStaticParams()), document.body.addEventListener(
      "mousemove",
      (o) => {
        var c, d;
        if (this.menuFrozen)
          return;
        const i = this.editor.view.dom.firstChild.getBoundingClientRect();
        this.horizontalPosAnchor = i.x;
        const s = {
          left: i.left + i.width / 2,
          top: o.clientY
        }, l = Bn(s, this.editor.view);
        if (!l) {
          this.menuOpen && (this.menuOpen = !1, this.blockMenu.hide());
          return;
        }
        if (this.menuOpen && ((c = this.hoveredBlockContent) == null ? void 0 : c.hasAttribute("data-id")) && ((d = this.hoveredBlockContent) == null ? void 0 : d.getAttribute("data-id")) === l.id)
          return;
        const a = l.node.firstChild;
        this.hoveredBlockContent = a, a && (this.menuOpen ? this.blockMenu.render(this.getDynamicParams(), !1) : (this.menuOpen = !0, this.blockMenu.render(this.getDynamicParams(), !0)));
      },
      !0
    ), document.body.addEventListener(
      "mousedown",
      (o) => {
        var i;
        (i = this.blockMenu.element) != null && i.contains(o.target) || (this.menuOpen && (this.menuOpen = !1, this.blockMenu.hide()), this.menuFrozen = !1);
      },
      !0
    ), document.body.addEventListener(
      "keydown",
      () => {
        this.menuOpen && (this.menuOpen = !1, this.blockMenu.hide()), this.menuFrozen = !1;
      },
      !0
    );
  }
  destroy() {
    this.menuOpen && (this.menuOpen = !1, this.blockMenu.hide());
  }
  addBlock() {
    this.menuOpen = !1, this.menuFrozen = !0, this.blockMenu.hide();
    const e = this.hoveredBlockContent.getBoundingClientRect(), t = this.editor.view.posAtCoords({
      left: e.left + e.width / 2,
      top: e.top + e.height / 2
    });
    if (!t)
      return;
    const r = T(this.editor.state.doc, t.pos);
    if (r === void 0)
      return;
    const { contentNode: o, endPos: i } = r;
    if (o.textContent.length !== 0) {
      const s = i + 1, l = s + 2;
      this.editor.chain().BNCreateBlock(s).BNUpdateBlock(l, { type: "paragraph", props: {} }).setTextSelection(l).run();
    } else
      this.editor.commands.setTextSelection(i);
    this.editor.view.focus(), this.editor.view.dispatch(
      this.editor.view.state.tr.scrollIntoView().setMeta(gt, {
        activate: !0,
        type: "drag"
      })
    );
  }
  deleteBlock() {
    this.menuOpen = !1, this.blockMenu.hide();
    const e = this.hoveredBlockContent.getBoundingClientRect(), t = this.editor.view.posAtCoords({
      left: e.left + e.width / 2,
      top: e.top + e.height / 2
    });
    !t || this.editor.commands.BNDeleteBlock(t.pos);
  }
  setBlockBackgroundColor(e) {
    this.menuOpen = !1, this.blockMenu.hide();
    const t = this.hoveredBlockContent.getBoundingClientRect(), r = this.editor.view.posAtCoords({
      left: t.left + t.width / 2,
      top: t.top + t.height / 2
    });
    !r || this.editor.commands.setBlockBackgroundColor(r.pos, e);
  }
  setBlockTextColor(e) {
    this.menuOpen = !1, this.blockMenu.hide();
    const t = this.hoveredBlockContent.getBoundingClientRect(), r = this.editor.view.posAtCoords({
      left: t.left + t.width / 2,
      top: t.top + t.height / 2
    });
    !r || this.editor.commands.setBlockTextColor(r.pos, e);
  }
  getStaticParams() {
    return {
      addBlock: () => this.addBlock(),
      deleteBlock: () => this.deleteBlock(),
      blockDragStart: (e) => wo(e, this.editor.view),
      blockDragEnd: () => Eo(),
      freezeMenu: () => {
        this.menuFrozen = !0;
      },
      unfreezeMenu: () => {
        this.menuFrozen = !1;
      },
      setBlockBackgroundColor: (e) => this.setBlockBackgroundColor(e),
      setBlockTextColor: (e) => this.setBlockTextColor(e)
    };
  }
  getDynamicParams() {
    const e = this.hoveredBlockContent.getBoundingClientRect();
    return {
      blockBackgroundColor: this.editor.getAttributes("blockContainer").backgroundColor,
      blockTextColor: this.editor.getAttributes("blockContainer").textColor,
      referenceRect: new DOMRect(
        this.horizontalPosAnchoredAtRoot ? this.horizontalPosAnchor : e.x,
        e.y,
        e.width,
        e.height
      )
    };
  }
}
const vo = (n) => new J({
  key: new L("DraggableBlocksPlugin"),
  view: () => new No({
    editor: n.editor,
    blockMenuFactory: n.blockSideMenuFactory,
    horizontalPosAnchoredAtRoot: !0
  })
}), Bo = $.create({
  name: "DraggableBlocksExtension",
  priority: 1e3,
  addProseMirrorPlugins() {
    if (!this.options.blockSideMenuFactory)
      throw new Error(
        "UI Element factory not defined for DraggableBlocksExtension"
      );
    return [
      vo({
        editor: this.editor,
        blockSideMenuFactory: this.options.blockSideMenuFactory
      })
    ];
  }
}), Io = new L("HyperlinkToolbarPlugin");
class Ao {
  constructor({ editor: e, hyperlinkToolbarFactory: t }) {
    m(this, "editor");
    m(this, "hyperlinkToolbar");
    m(this, "menuUpdateTimer");
    m(this, "startMenuUpdateTimer");
    m(this, "stopMenuUpdateTimer");
    m(this, "mouseHoveredHyperlinkMark");
    m(this, "mouseHoveredHyperlinkMarkRange");
    m(this, "keyboardHoveredHyperlinkMark");
    m(this, "keyboardHoveredHyperlinkMarkRange");
    m(this, "hyperlinkMark");
    m(this, "hyperlinkMarkRange");
    this.editor = e, this.hyperlinkToolbar = t(this.getStaticParams()), this.startMenuUpdateTimer = () => {
      this.menuUpdateTimer = setTimeout(() => {
        this.update();
      }, 250);
    }, this.stopMenuUpdateTimer = () => (this.menuUpdateTimer && (clearTimeout(this.menuUpdateTimer), this.menuUpdateTimer = void 0), !1), e.view.dom.addEventListener("mouseover", (r) => {
      if (this.mouseHoveredHyperlinkMark = void 0, this.mouseHoveredHyperlinkMarkRange = void 0, this.stopMenuUpdateTimer(), r.target instanceof HTMLAnchorElement && r.target.nodeName === "A") {
        const o = r.target, i = e.view.posAtDOM(o, 0) + 1, s = e.state.doc.resolve(
          i
        ), l = s.marks();
        for (const a of l)
          if (a.type.name === e.schema.mark("link").type.name) {
            this.mouseHoveredHyperlinkMark = a, this.mouseHoveredHyperlinkMarkRange = yt(
              s,
              a.type,
              a.attrs
            ) || void 0;
            break;
          }
      }
      return this.startMenuUpdateTimer(), !1;
    });
  }
  update() {
    var t, r, o, i;
    if (!this.editor.view.hasFocus())
      return;
    const e = this.hyperlinkMark;
    if (this.hyperlinkMark = void 0, this.hyperlinkMarkRange = void 0, this.keyboardHoveredHyperlinkMark = void 0, this.keyboardHoveredHyperlinkMarkRange = void 0, this.editor.state.selection.empty) {
      const s = this.editor.state.selection.$from.marks();
      for (const l of s)
        if (l.type.name === this.editor.schema.mark("link").type.name) {
          this.keyboardHoveredHyperlinkMark = l, this.keyboardHoveredHyperlinkMarkRange = yt(
            this.editor.state.selection.$from,
            l.type,
            l.attrs
          ) || void 0;
          break;
        }
    }
    if (this.mouseHoveredHyperlinkMark && (this.hyperlinkMark = this.mouseHoveredHyperlinkMark, this.hyperlinkMarkRange = this.mouseHoveredHyperlinkMarkRange), this.keyboardHoveredHyperlinkMark && (this.hyperlinkMark = this.keyboardHoveredHyperlinkMark, this.hyperlinkMarkRange = this.keyboardHoveredHyperlinkMarkRange), this.hyperlinkMark) {
      if (this.getDynamicParams(), !e) {
        this.hyperlinkToolbar.render(this.getDynamicParams(), !0), (t = this.hyperlinkToolbar.element) == null || t.addEventListener(
          "mouseleave",
          this.startMenuUpdateTimer
        ), (r = this.hyperlinkToolbar.element) == null || r.addEventListener(
          "mouseenter",
          this.stopMenuUpdateTimer
        );
        return;
      }
      this.hyperlinkToolbar.render(this.getDynamicParams(), !1);
      return;
    }
    if (!this.hyperlinkMark && e) {
      (o = this.hyperlinkToolbar.element) == null || o.removeEventListener(
        "mouseleave",
        this.startMenuUpdateTimer
      ), (i = this.hyperlinkToolbar.element) == null || i.removeEventListener(
        "mouseenter",
        this.stopMenuUpdateTimer
      ), this.hyperlinkToolbar.hide();
      return;
    }
  }
  getStaticParams() {
    return {
      editHyperlink: (e, t) => {
        const r = this.editor.view.state.tr.insertText(
          t,
          this.hyperlinkMarkRange.from,
          this.hyperlinkMarkRange.to
        );
        r.addMark(
          this.hyperlinkMarkRange.from,
          this.hyperlinkMarkRange.from + t.length,
          this.editor.schema.mark("link", { href: e })
        ), this.editor.view.dispatch(r), this.editor.view.focus(), this.hyperlinkToolbar.hide();
      },
      deleteHyperlink: () => {
        this.editor.view.dispatch(
          this.editor.view.state.tr.removeMark(
            this.hyperlinkMarkRange.from,
            this.hyperlinkMarkRange.to,
            this.hyperlinkMark.type
          ).setMeta("preventAutolink", !0)
        ), this.editor.view.focus(), this.hyperlinkToolbar.hide();
      }
    };
  }
  getDynamicParams() {
    return {
      url: this.hyperlinkMark.attrs.href,
      text: this.editor.view.state.doc.textBetween(
        this.hyperlinkMarkRange.from,
        this.hyperlinkMarkRange.to
      ),
      referenceRect: Vt(
        this.editor.view,
        this.hyperlinkMarkRange.from,
        this.hyperlinkMarkRange.to
      )
    };
  }
}
const Oo = (n, e) => new J({
  key: Io,
  view: () => new Ao({
    editor: n,
    hyperlinkToolbarFactory: e.hyperlinkToolbarFactory
  })
}), Po = Kt.extend({
  priority: 500,
  addProseMirrorPlugins() {
    var n;
    if (!this.options.hyperlinkToolbarFactory)
      throw new Error("UI Element factory not defined for HyperlinkMark");
    return [
      ...((n = this.parent) == null ? void 0 : n.call(this)) || [],
      Oo(this.editor, {
        hyperlinkToolbarFactory: this.options.hyperlinkToolbarFactory
      })
    ];
  }
}), Do = new L("blocknote-placeholder"), Ro = $.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      isFilterClass: "is-filter",
      hasAnchorClass: "has-anchor",
      placeholder: "Write something \u2026",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new J({
        key: Do,
        props: {
          decorations: (n) => {
            const { doc: e, selection: t } = n, r = gt.getState(n), o = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: i } = t, s = [];
            if (!!o)
              return e.descendants((l, a) => {
                const c = i >= a && i <= a + l.nodeSize, d = !l.isLeaf && !l.childCount;
                if ((c || !this.options.showOnlyCurrent) && d) {
                  const h = [this.options.emptyNodeClass];
                  this.editor.isEmpty && h.push(this.options.emptyEditorClass), c && h.push(this.options.hasAnchorClass), (r == null ? void 0 : r.triggerCharacter) === "" && (r == null ? void 0 : r.active) && h.push(this.options.isFilterClass);
                  const u = I.node(a, a + l.nodeSize, {
                    class: h.join(" ")
                  });
                  s.push(u);
                }
                return this.options.includeChildren;
              }), M.create(e, s);
          }
        }
      })
    ];
  }
}), zo = $.create({
  name: "trailingNode",
  addProseMirrorPlugins() {
    const n = new L(this.name);
    return [
      new J({
        key: n,
        appendTransaction: (e, t, r) => {
          const { doc: o, tr: i, schema: s } = r, l = n.getState(r), a = o.content.size - 2, c = s.nodes.blockContainer, d = s.nodes.paragraph;
          if (!!l)
            return i.insert(
              a,
              c.create(void 0, d.create())
            );
        },
        state: {
          init: (e, t) => {
          },
          apply: (e, t) => {
            if (!e.docChanged)
              return t;
            let r = e.doc.lastChild;
            if (!r || r.type.name !== "blockGroup")
              throw new Error("Expected blockGroup");
            if (r = r.lastChild, !r || r.type.name !== "blockContainer")
              throw new Error("Expected blockContainer");
            return r.nodeSize > 4;
          }
        }
      })
    ];
  }
});
function Fo(n, e = JSON.stringify) {
  const t = {};
  return n.filter((r) => {
    const o = e(r);
    return Object.prototype.hasOwnProperty.call(t, o) ? !1 : t[o] = !0;
  });
}
function Lo(n) {
  const e = n.filter(
    (r, o) => n.indexOf(r) !== o
  );
  return Fo(e);
}
const Ho = $.create({
  name: "uniqueID",
  priority: 1e4,
  addOptions() {
    return {
      attributeName: "id",
      types: [],
      generateID: () => window.__TEST_OPTIONS ? (window.__TEST_OPTIONS.mockID === void 0 ? window.__TEST_OPTIONS.mockID = 0 : window.__TEST_OPTIONS.mockID++, parseInt(window.__TEST_OPTIONS.mockID)) : Xn(),
      filterTransaction: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          [this.options.attributeName]: {
            default: null,
            parseHTML: (n) => n.getAttribute(`data-${this.options.attributeName}`),
            renderHTML: (n) => ({
              [`data-${this.options.attributeName}`]: n[this.options.attributeName]
            })
          }
        }
      }
    ];
  },
  onCreate() {
    if (this.editor.extensionManager.extensions.find(
      (a) => a.name === "collaboration"
    ))
      return;
    const { view: n, state: e } = this.editor, { tr: t, doc: r } = e, { types: o, attributeName: i, generateID: s } = this.options;
    Ke(r, (a) => o.includes(a.type.name) && a.attrs[i] === null).forEach(({ node: a, pos: c }) => {
      t.setNodeMarkup(c, void 0, {
        ...a.attrs,
        [i]: s()
      });
    }), t.setMeta("addToHistory", !1), n.dispatch(t);
  },
  addProseMirrorPlugins() {
    let n = null, e = !1;
    return [
      new J({
        key: new L("uniqueID"),
        appendTransaction: (t, r, o) => {
          console.log("appendTransaction");
          const i = t.some((k) => k.docChanged) && !r.doc.eq(o.doc), s = this.options.filterTransaction && t.some((k) => {
            var S, C;
            return !(!((C = (S = this.options).filterTransaction) === null || C === void 0) && C.call(S, k));
          });
          if (!i || s)
            return;
          const { tr: l } = o, { types: a, attributeName: c, generateID: d } = this.options, h = zn(
            r.doc,
            t
          ), { mapping: u } = h;
          if (Fn(h).forEach(({ newRange: k }) => {
            const S = Ln(
              o.doc,
              k,
              (B) => a.includes(B.type.name)
            ), C = S.map(({ node: B }) => B.attrs[c]).filter((B) => B !== null), w = Lo(C);
            S.forEach(({ node: B, pos: K }) => {
              var Fe;
              const kt = (Fe = l.doc.nodeAt(K)) === null || Fe === void 0 ? void 0 : Fe.attrs[c];
              if (kt === null) {
                l.setNodeMarkup(K, void 0, {
                  ...B.attrs,
                  [c]: d()
                });
                return;
              }
              const { deleted: In } = u.invert().mapResult(K);
              In && w.includes(kt) && l.setNodeMarkup(K, void 0, {
                ...B.attrs,
                [c]: d()
              });
            });
          }), !!l.steps.length)
            return l;
        },
        view(t) {
          const r = (o) => {
            var i;
            n = !((i = t.dom.parentElement) === null || i === void 0) && i.contains(o.target) ? t.dom.parentElement : null;
          };
          return window.addEventListener("dragstart", r), {
            destroy() {
              window.removeEventListener("dragstart", r);
            }
          };
        },
        props: {
          handleDOMEvents: {
            drop: (t, r) => {
              var o;
              return (n !== t.dom.parentElement || ((o = r.dataTransfer) === null || o === void 0 ? void 0 : o.effectAllowed) === "copy") && (n = null, e = !0), !1;
            },
            paste: () => (e = !0, !1)
          },
          transformPasted: (t) => {
            if (!e)
              return t;
            const { types: r, attributeName: o } = this.options, i = (s) => {
              const l = [];
              return s.forEach((a) => {
                if (a.isText) {
                  l.push(a);
                  return;
                }
                if (!r.includes(a.type.name)) {
                  l.push(a.copy(i(a.content)));
                  return;
                }
                const c = a.type.create(
                  {
                    ...a.attrs,
                    [o]: null
                  },
                  i(a.content),
                  a.marks
                );
                l.push(c);
              }), g.from(l);
            };
            return e = !1, new p(
              i(t.content),
              t.openStart,
              t.openEnd
            );
          }
        }
      })
    ];
  }
}), $o = Wt.create({
  name: "backgroundColor",
  addAttributes() {
    return {
      color: {
        default: void 0,
        parseHTML: (n) => n.getAttribute("data-background-color"),
        renderHTML: (n) => ({
          "data-background-color": n.color
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (n) => typeof n == "string" ? !1 : n.hasAttribute("data-background-color") ? { color: n.getAttribute("data-background-color") } : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", n, 0];
  },
  addCommands() {
    return {
      setBackgroundColor: (n) => ({ commands: e }) => n !== "default" ? e.setMark(this.name, { color: n }) : e.unsetMark(this.name)
    };
  }
}), Jo = Wt.create({
  name: "textColor",
  addAttributes() {
    return {
      color: {
        default: void 0,
        parseHTML: (n) => n.getAttribute("data-text-color"),
        renderHTML: (n) => ({
          "data-text-color": n.color
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (n) => typeof n == "string" ? !1 : n.hasAttribute("data-text-color") ? { color: n.getAttribute("data-text-color") } : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", n, 0];
  },
  addCommands() {
    return {
      setTextColor: (n) => ({ commands: e }) => n !== "default" ? e.setMark(this.name, { color: n }) : e.unsetMark(this.name)
    };
  }
}), qo = $.create({
  name: "blockBackgroundColor",
  addGlobalAttributes() {
    return [
      {
        types: ["blockContainer"],
        attributes: {
          backgroundColor: {
            default: "default",
            parseHTML: (n) => n.hasAttribute("data-background-color") ? n.getAttribute("data-background-color") : "default",
            renderHTML: (n) => n.backgroundColor !== "default" && {
              "data-background-color": n.backgroundColor
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBlockBackgroundColor: (n, e) => ({ state: t, view: r }) => {
        const o = T(t.doc, n);
        return o === void 0 ? !1 : (t.tr.setNodeAttribute(
          o.startPos - 1,
          "backgroundColor",
          e
        ), r.focus(), !0);
      }
    };
  }
}), Uo = $.create({
  name: "blockTextColor",
  addGlobalAttributes() {
    return [
      {
        types: ["blockContainer"],
        attributes: {
          textColor: {
            default: "default",
            parseHTML: (n) => n.hasAttribute("data-text-color") ? n.getAttribute("data-text-color") : "default",
            renderHTML: (n) => n.textColor !== "default" && {
              "data-text-color": n.textColor
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBlockTextColor: (n, e) => ({ state: t, view: r }) => {
        const o = T(t.doc, n);
        return o === void 0 ? !1 : (t.tr.setNodeAttribute(o.startPos - 1, "textColor", e), r.focus(), !0);
      }
    };
  }
}), Vo = $.create({
  name: "textAlignment",
  addGlobalAttributes() {
    return [
      {
        types: ["paragraph", "heading", "bulletListItem", "numberedListItem"],
        attributes: {
          textAlignment: {
            default: "left",
            parseHTML: (n) => n.getAttribute("data-text-alignment"),
            renderHTML: (n) => n.textAlignment !== "left" && {
              "data-text-alignment": n.textAlignment
            }
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlignment: (n) => ({ state: e }) => {
        const t = [], r = T(
          e.doc,
          e.selection.from
        );
        if (r === void 0)
          return !1;
        let o = r.startPos;
        for (; o < e.selection.to; )
          e.doc.resolve(o).node().type.spec.group === "blockContent" ? (t.push(o - 1), o += e.doc.resolve(o).node().nodeSize - 1) : o += 1;
        for (const i of t)
          e.tr.setNodeAttribute(i, "textAlignment", n);
        return !0;
      }
    };
  }
}), Wo = (n) => {
  const e = [
    ue.ClipboardTextSerializer,
    ue.Commands,
    ue.Editable,
    ue.FocusEvents,
    ue.Tabindex,
    Un,
    Ro.configure({
      emptyNodeClass: F.isEmpty,
      hasAnchorClass: F.hasAnchor,
      isFilterClass: F.isFilter,
      includeChildren: !0,
      showOnlyCurrent: !1
    }),
    Ho.configure({
      types: ["blockContainer"]
    }),
    Vn,
    Yn,
    $n,
    Jn,
    Kn,
    Gn,
    _n,
    Jo,
    Uo,
    $o,
    qo,
    Vo,
    ...co,
    qn.configure({ width: 5, color: "#ddeeff" }),
    Wn,
    zo
  ];
  return n.blockSideMenuFactory && e.push(
    Bo.configure({
      blockSideMenuFactory: n.blockSideMenuFactory
    })
  ), n.formattingToolbarFactory && e.push(
    fo.configure({
      formattingToolbarFactory: n.formattingToolbarFactory
    })
  ), n.hyperlinkToolbarFactory ? e.push(
    Po.configure({
      hyperlinkToolbarFactory: n.hyperlinkToolbarFactory
    })
  ) : e.push(Kt), n.slashMenuFactory && e.push(
    So.configure({
      slashMenuFactory: n.slashMenuFactory
    })
  ), e;
}, Ko = {
  enableInputRules: !0,
  enablePasteRules: !0,
  enableCoreExtensions: !1
};
class ai {
  constructor(e = {}) {
    m(this, "tiptapEditor");
    var i, s, l;
    const t = Wo(
      e.uiFactories || {}
    );
    let r = e.disableHistoryExtension ? t.filter((a) => a.name !== "history") : t;
    const o = {
      ...Ko,
      ...e,
      extensions: e.enableBlockNoteExtensions === !1 ? e.extensions : [...e.extensions || [], ...r],
      editorProps: {
        attributes: {
          ...((i = e.editorProps) == null ? void 0 : i.attributes) || {},
          class: [
            nt.bnEditor,
            nt.bnRoot,
            ((l = (s = e.editorProps) == null ? void 0 : s.attributes) == null ? void 0 : l.class) || ""
          ].join(" ")
        }
      }
    };
    this.tiptapEditor = new Hn(o);
  }
}
export {
  ai as BlockNoteEditor,
  ie as SlashMenuItem,
  Wo as getBlockNoteExtensions
};
//# sourceMappingURL=blocknote.js.map
